<template>
  <div class="dashboard-container" style="overflow: hidden;">
    <div class="block" style="margin-left:10px; ">
      <div style="text-align: start;">
        <p style="margin:12px 12px 17px 12px;display: flex">
          <span class="query" style="width: 64px;  padding-top: 8px;">时间查询:</span>
          <el-date-picker value-format="yyyy-MM-dd" v-model="createTime" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" @change="handleClear" clearable>
          </el-date-picker>
        </p>
      </div>
       <div style="padding-top: 17px;width: 40%; display: flex;">
            <el-button style="height: 30px;" size="small" type="primary" @click="handleToToday">今日</el-button>
            <el-button style="height: 30px;" size="small" type="primary" @click="handleToYesterday">昨天</el-button>
            <el-button style="height: 30px;" size="small" type="primary" @click="handleToLastSevenDays">近七天</el-button>
       </div>
    </div>

    <div class="title">客资分析 {{ handleGetTimeString(createTime && createTime.length > 0 ? createTime[0] : '') }} - {{ handleGetTimeString(createTime && createTime.length > 0 ? createTime[1] : '' ) }}</div>
    <div class="textbox">
      <div class="all">
        <div class="title" style="border-bottom: 1px solid #ccc;">新增客资数</div>
        <div class="item" style="height: 55%;">
          <span style="font-size: 24px; font-weight: bold;">{{ addCustomerNum }}条</span>
          <svg height="80" node-id="1" sillyvg="true" template-height="237" template-width="251" version="1.1"
            viewBox="0 0 251 237" width="80" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs node-id="132"></defs>
            <path
              d="M 249.75 108.56 C 249.75 68.29 217.83 35.64 178.47 35.64 C 177.85 35.64 177.25 35.67 176.64 35.69 C 164.21 14.32 141.42 0.00 115.35 0.00 C 75.98 0.00 44.07 32.65 44.07 72.92 C 44.07 73.44 44.10 73.96 44.11 74.48 C 22.58 87.03 8.05 110.70 8.05 137.87 C 8.05 178.14 39.96 210.78 79.33 210.78 C 81.57 210.78 83.78 210.66 85.97 210.46 C 99.04 226.66 119.79 236.99 141.93 236.99 C 178.32 236.99 207.35 209.09 211.69 173.07 C 234.32 160.85 249.75 136.56 249.75 108.56 Z"
              fill="#fff8df" fill-rule="nonzero" node-id="134" stroke="none" target-height="236.988" target-width="241.7"
              target-x="8.047" target-y="0" />
            <g node-id="499">
              <g node-id="506">
                <path d="M 236.44 89.28 L 156.18 89.28 L 156.18 207.19 L 249.40 207.19 L 249.40 101.62 Z" fill="#ffffff"
                  fill-rule="nonzero" group-id="1,8" node-id="140" stroke="none" target-height="117.91599"
                  target-width="93.218" target-x="156.179" target-y="89.277" />
                <path
                  d="M 249.40 208.69 L 156.18 208.69 C 155.35 208.69 154.68 208.02 154.68 207.19 L 154.68 89.28 C 154.68 88.45 155.35 87.78 156.18 87.78 L 236.44 87.78 C 236.82 87.78 237.19 87.92 237.47 88.19 L 250.43 100.54 C 250.73 100.82 250.90 101.21 250.90 101.62 L 250.90 207.19 C 250.90 208.02 250.22 208.69 249.40 208.69 Z M 157.68 205.69 L 247.90 205.69 L 247.90 102.27 L 235.84 90.78 L 157.68 90.78 L 157.68 205.69 Z"
                  fill="#ccccde" fill-rule="nonzero" group-id="1,8" node-id="142" stroke="none" target-height="120.91599"
                  target-width="96.218" target-x="154.679" target-y="87.777" />
              </g>
              <g node-id="507">
                <path d="M 249.40 101.62 L 236.44 101.62 L 236.44 89.28 Z" fill="#ffffff" fill-rule="nonzero"
                  group-id="1,9" node-id="147" stroke="none" target-height="12.348" target-width="12.962006"
                  target-x="236.435" target-y="89.277" />
                <path
                  d="M 249.42 103.12 C 249.41 103.12 249.40 103.12 249.40 103.12 L 236.43 103.12 C 235.61 103.12 234.93 102.45 234.93 101.62 L 234.93 89.28 C 234.93 88.68 235.29 88.13 235.84 87.90 C 236.40 87.66 237.03 87.78 237.47 88.19 L 250.29 100.41 C 250.67 100.68 250.91 101.12 250.91 101.62 C 250.92 102.45 250.25 103.12 249.42 103.12 Z M 237.94 100.12 L 245.65 100.12 L 237.94 92.78 L 237.94 100.12 Z"
                  fill="#ccccde" fill-rule="nonzero" group-id="1,9" node-id="149" stroke="none" target-height="15.463997"
                  target-width="15.981995" target-x="234.934" target-y="87.661" />
              </g>
              <g node-id="508">
                <path
                  d="M 209.28 109.37 L 192.65 109.37 C 191.82 109.37 191.15 108.70 191.15 107.87 C 191.15 107.04 191.82 106.37 192.65 106.37 L 209.28 106.37 C 210.11 106.37 210.78 107.04 210.78 107.87 C 210.78 108.70 210.11 109.37 209.28 109.37 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,10" node-id="154" stroke="none"
                  target-height="3" target-width="19.630997" target-x="191.147" target-y="106.368" />
              </g>
              <g node-id="509">
                <path
                  d="M 213.12 120.64 L 170.90 120.64 C 170.07 120.64 169.40 119.96 169.40 119.14 C 169.40 118.31 170.07 117.64 170.90 117.64 L 213.12 117.64 C 213.94 117.64 214.62 118.31 214.62 119.14 C 214.62 119.96 213.94 120.64 213.12 120.64 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,11" node-id="159" stroke="none"
                  target-height="3" target-width="45.218002" target-x="169.397" target-y="117.636" />
                <path
                  d="M 231.66 120.64 L 222.07 120.64 C 221.25 120.64 220.57 119.96 220.57 119.14 C 220.57 118.31 221.25 117.64 222.07 117.64 L 231.66 117.64 C 232.49 117.64 233.16 118.31 233.16 119.14 C 233.16 119.96 232.49 120.64 231.66 120.64 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,11" node-id="161" stroke="none"
                  target-height="3" target-width="12.591995" target-x="220.573" target-y="117.636" />
                <path
                  d="M 205.44 126.39 L 170.90 126.39 C 170.07 126.39 169.40 125.72 169.40 124.89 C 169.40 124.06 170.07 123.39 170.90 123.39 L 205.44 123.39 C 206.27 123.39 206.94 124.06 206.94 124.89 C 206.94 125.72 206.27 126.39 205.44 126.39 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,11" node-id="163" stroke="none"
                  target-height="3" target-width="37.542007" target-x="169.398" target-y="123.393" />
                <path
                  d="M 231.66 126.39 L 209.92 126.39 C 209.09 126.39 208.42 125.72 208.42 124.89 C 208.42 124.06 209.09 123.39 209.92 123.39 L 231.66 123.39 C 232.49 123.39 233.16 124.06 233.16 124.89 C 233.16 125.72 232.49 126.39 231.66 126.39 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,11" node-id="165" stroke="none"
                  target-height="3" target-width="24.745987" target-x="208.419" target-y="123.393" />
                <path
                  d="M 187.21 133.43 L 170.90 133.43 C 170.07 133.43 169.40 132.76 169.40 131.93 C 169.40 131.10 170.07 130.43 170.90 130.43 L 187.21 130.43 C 188.04 130.43 188.71 131.10 188.71 131.93 C 188.71 132.76 188.04 133.43 187.21 133.43 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,11" node-id="167" stroke="none"
                  target-height="3" target-width="19.315002" target-x="169.398" target-y="130.43" />
                <path
                  d="M 202.88 133.43 L 193.28 133.43 C 192.46 133.43 191.78 132.76 191.78 131.93 C 191.78 131.10 192.46 130.43 193.28 130.43 L 202.88 130.43 C 203.71 130.43 204.38 131.10 204.38 131.93 C 204.38 132.76 203.71 133.43 202.88 133.43 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,11" node-id="169" stroke="none"
                  target-height="3" target-width="12.597" target-x="191.785" target-y="130.43" />
                <path
                  d="M 231.66 133.43 L 207.36 133.43 C 206.53 133.43 205.86 132.76 205.86 131.93 C 205.86 131.10 206.53 130.43 207.36 130.43 L 231.67 130.43 C 232.49 130.43 233.17 131.10 233.17 131.93 C 233.17 132.76 232.49 133.43 231.66 133.43 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,11" node-id="171" stroke="none"
                  target-height="3" target-width="27.306" target-x="205.86" target-y="130.43" />
                <path
                  d="M 196.81 140.47 L 170.90 140.47 C 170.07 140.47 169.40 139.79 169.40 138.97 C 169.40 138.14 170.07 137.47 170.90 137.47 L 196.81 137.47 C 197.63 137.47 198.31 138.14 198.31 138.97 C 198.31 139.79 197.63 140.47 196.81 140.47 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,11" node-id="173" stroke="none"
                  target-height="3" target-width="28.906998" target-x="169.398" target-y="137.465" />
                <path
                  d="M 207.04 140.47 L 203.84 140.47 C 203.01 140.47 202.34 139.79 202.34 138.97 C 202.34 138.14 203.01 137.47 203.84 137.47 L 207.04 137.47 C 207.87 137.47 208.54 138.14 208.54 138.97 C 208.54 139.79 207.87 140.47 207.04 140.47 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,11" node-id="175" stroke="none"
                  target-height="3" target-width="6.199005" target-x="202.342" target-y="137.465" />
                <path
                  d="M 231.66 140.47 L 213.44 140.47 C 212.61 140.47 211.94 139.79 211.94 138.97 C 211.94 138.14 212.61 137.47 213.44 137.47 L 231.66 137.47 C 232.49 137.47 233.16 138.14 233.16 138.97 C 233.16 139.79 232.49 140.47 231.66 140.47 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,11" node-id="177" stroke="none"
                  target-height="3" target-width="21.229996" target-x="211.935" target-y="137.465" />
              </g>
              <g node-id="510">
                <path
                  d="M 208.32 192.84 C 207.98 192.84 207.65 192.73 207.37 192.50 C 206.73 191.97 206.64 191.02 207.17 190.39 C 213.03 183.32 217.14 180.26 219.36 181.28 C 221.31 182.18 220.83 184.94 220.68 185.84 C 220.31 187.98 220.32 189.07 220.39 189.59 C 221.27 189.07 222.78 187.56 223.41 186.93 C 224.67 185.67 225.85 185.25 226.91 185.69 C 227.44 185.91 227.80 186.30 228.05 186.72 L 231.73 185.16 C 232.49 184.84 233.37 185.20 233.69 185.96 C 234.02 186.72 233.66 187.60 232.90 187.93 L 227.62 190.16 C 227.16 190.36 226.63 190.31 226.21 190.03 C 225.86 189.80 225.62 189.44 225.56 189.03 C 225.55 189.03 225.54 189.04 225.54 189.05 C 223.41 191.17 221.01 193.58 218.90 192.49 C 216.95 191.48 217.21 188.30 217.72 185.33 C 217.81 184.84 217.83 184.48 217.84 184.24 C 216.25 185.03 212.64 188.50 209.48 192.30 C 209.18 192.66 208.75 192.84 208.32 192.84 Z"
                  fill="#6e6e96" fill-opacity="0.3" fill-rule="nonzero" group-id="1,12" node-id="182" stroke="none"
                  target-height="13.318008" target-width="27.376999" target-x="206.639" target-y="180.262" />
              </g>
              <g node-id="511">
                <path
                  d="M 205.12 147.18 L 170.90 147.18 C 170.07 147.18 169.40 146.51 169.40 145.68 C 169.40 144.86 170.07 144.18 170.90 144.18 L 205.12 144.18 C 205.95 144.18 206.62 144.86 206.62 145.68 C 206.62 146.51 205.95 147.18 205.12 147.18 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,13" node-id="187" stroke="none"
                  target-height="3" target-width="37.224" target-x="169.397" target-y="144.184" />
              </g>
              <g node-id="512">
                <path
                  d="M 213.12 153.13 L 170.90 153.13 C 170.07 153.13 169.40 152.46 169.40 151.63 C 169.40 150.80 170.07 150.13 170.90 150.13 L 213.12 150.13 C 213.94 150.13 214.62 150.80 214.62 151.63 C 214.62 152.46 213.94 153.13 213.12 153.13 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,14" node-id="192" stroke="none"
                  target-height="3" target-width="45.218002" target-x="169.397" target-y="150.13" />
                <path
                  d="M 231.66 153.13 L 222.07 153.13 C 221.25 153.13 220.57 152.46 220.57 151.63 C 220.57 150.80 221.25 150.13 222.07 150.13 L 231.66 150.13 C 232.49 150.13 233.16 150.80 233.16 151.63 C 233.16 152.46 232.49 153.13 231.66 153.13 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,14" node-id="194" stroke="none"
                  target-height="3" target-width="12.591995" target-x="220.573" target-y="150.13" />
                <path
                  d="M 205.44 158.89 L 170.90 158.89 C 170.07 158.89 169.40 158.22 169.40 157.39 C 169.40 156.56 170.07 155.89 170.90 155.89 L 205.44 155.89 C 206.27 155.89 206.94 156.56 206.94 157.39 C 206.94 158.22 206.27 158.89 205.44 158.89 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,14" node-id="196" stroke="none"
                  target-height="3" target-width="37.542007" target-x="169.398" target-y="155.889" />
                <path
                  d="M 231.66 158.89 L 209.92 158.89 C 209.09 158.89 208.42 158.22 208.42 157.39 C 208.42 156.56 209.09 155.89 209.92 155.89 L 231.66 155.89 C 232.49 155.89 233.16 156.56 233.16 157.39 C 233.16 158.22 232.49 158.89 231.66 158.89 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,14" node-id="198" stroke="none"
                  target-height="3" target-width="24.745987" target-x="208.419" target-y="155.889" />
                <path
                  d="M 187.21 165.93 L 170.90 165.93 C 170.07 165.93 169.40 165.25 169.40 164.43 C 169.40 163.60 170.07 162.93 170.90 162.93 L 187.21 162.93 C 188.04 162.93 188.71 163.60 188.71 164.43 C 188.71 165.25 188.04 165.93 187.21 165.93 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,14" node-id="200" stroke="none"
                  target-height="3" target-width="19.315002" target-x="169.398" target-y="162.926" />
                <path
                  d="M 202.88 165.93 L 193.28 165.93 C 192.46 165.93 191.78 165.25 191.78 164.43 C 191.78 163.60 192.46 162.93 193.28 162.93 L 202.88 162.93 C 203.71 162.93 204.38 163.60 204.38 164.43 C 204.38 165.25 203.71 165.93 202.88 165.93 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,14" node-id="202" stroke="none"
                  target-height="3" target-width="12.597" target-x="191.785" target-y="162.926" />
                <path
                  d="M 231.66 165.93 L 207.36 165.93 C 206.53 165.93 205.86 165.25 205.86 164.43 C 205.86 163.60 206.53 162.93 207.36 162.93 L 231.67 162.93 C 232.49 162.93 233.17 163.60 233.17 164.43 C 233.17 165.25 232.49 165.93 231.66 165.93 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,14" node-id="204" stroke="none"
                  target-height="3" target-width="27.306" target-x="205.86" target-y="162.926" />
                <path
                  d="M 196.81 172.96 L 170.90 172.96 C 170.07 172.96 169.40 172.29 169.40 171.46 C 169.40 170.63 170.07 169.96 170.90 169.96 L 196.81 169.96 C 197.63 169.96 198.31 170.63 198.31 171.46 C 198.31 172.29 197.63 172.96 196.81 172.96 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,14" node-id="206" stroke="none"
                  target-height="3" target-width="28.906998" target-x="169.398" target-y="169.961" />
                <path
                  d="M 207.04 172.96 L 203.84 172.96 C 203.01 172.96 202.34 172.29 202.34 171.46 C 202.34 170.63 203.01 169.96 203.84 169.96 L 207.04 169.96 C 207.87 169.96 208.54 170.63 208.54 171.46 C 208.54 172.29 207.87 172.96 207.04 172.96 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,14" node-id="208" stroke="none"
                  target-height="3" target-width="6.199005" target-x="202.342" target-y="169.961" />
                <path
                  d="M 231.66 172.96 L 213.44 172.96 C 212.61 172.96 211.94 172.29 211.94 171.46 C 211.94 170.63 212.61 169.96 213.44 169.96 L 231.66 169.96 C 232.49 169.96 233.16 170.63 233.16 171.46 C 233.16 172.29 232.49 172.96 231.66 172.96 Z"
                  fill="#6e6e96" fill-opacity="0.21" fill-rule="nonzero" group-id="1,14" node-id="210" stroke="none"
                  target-height="3" target-width="21.229996" target-x="211.935" target-y="169.961" />
              </g>
            </g>
            <g node-id="500">
              <g node-id="513">
                <path d="M 31.00 32.82 L 114.40 32.82 L 114.40 97.73 L 31.00 97.73 Z" fill="#ffffff" fill-rule="nonzero"
                  group-id="2,15" node-id="217" stroke="none" target-height="64.914" target-width="83.4" target-x="31"
                  target-y="32.816" />
                <path
                  d="M 114.40 99.23 L 31.00 99.23 C 30.17 99.23 29.50 98.56 29.50 97.73 L 29.50 32.82 C 29.50 31.99 30.17 31.32 31.00 31.32 L 114.40 31.32 C 115.23 31.32 115.90 31.99 115.90 32.82 L 115.90 97.73 C 115.90 98.56 115.23 99.23 114.40 99.23 Z M 32.50 96.23 L 112.90 96.23 L 112.90 34.32 L 32.50 34.32 L 32.50 96.23 Z"
                  fill="#ccccde" fill-rule="nonzero" group-id="2,15" node-id="219" stroke="none" target-height="67.914"
                  target-width="86.401" target-x="29.5" target-y="31.316" />
              </g>
              <g node-id="514">
                <path d="M 38.72 39.90 L 105.81 39.90 L 105.81 90.17 L 38.72 90.17 Z" fill="#d6f1ff" fill-rule="nonzero"
                  group-id="2,16" node-id="223" stroke="none" target-height="50.267998" target-width="67.085"
                  target-x="38.72" target-y="39.901" />
              </g>
              <g node-id="515">
                <g node-id="529">
                  <path
                    d="M 38.72 60.45 C 38.72 60.45 41.34 56.78 47.89 56.78 C 54.44 56.78 49.99 52.33 57.85 52.33 C 65.71 52.33 70.69 48.40 80.13 52.06 C 89.56 55.73 105.81 55.91 105.81 55.91 L 106.02 69.08 L 38.72 72.77 L 38.72 60.45 L 38.72 60.45 Z"
                    fill="#000000" fill-opacity="0.0376" fill-rule="nonzero" group-id="2,17,31" node-id="229"
                    stroke="none" target-height="24.368" target-width="67.298996" target-x="38.72" target-y="48.398" />
                </g>
                <path d="M 70.60 62.60 L 38.72 81.25 L 38.72 90.00 L 106.02 90.00 Z" fill="#ffe5b0" fill-opacity="0.47"
                  fill-rule="nonzero" group-id="2,17" node-id="232" stroke="none" target-height="27.404"
                  target-width="67.298996" target-x="38.72" target-y="62.6" />
                <path
                  d="M 38.72 69.80 C 38.72 69.80 48.57 64.13 54.74 64.70 C 60.92 65.26 50.76 74.21 50.76 74.21 L 38.72 81.25 L 38.72 69.80 Z"
                  fill="#ffe5b0" fill-opacity="0.47" fill-rule="nonzero" group-id="2,17" node-id="234" stroke="none"
                  target-height="17.122002" target-width="22.196" target-x="38.72" target-y="64.13" />
                <path
                  d="M 54.75 64.70 C 54.75 64.70 56.88 65.64 52.29 67.42 C 47.69 69.19 46.20 77.00 53.68 73.21 C 61.16 69.43 70.59 62.60 70.59 62.60 C 70.59 62.60 63.93 66.79 54.75 64.70 Z"
                  fill="#f2d9a6" fill-opacity="0.47" fill-rule="nonzero" group-id="2,17" node-id="236" stroke="none"
                  target-height="14.394001" target-width="24.395" target-x="46.2" target-y="62.602" />
                <path d="M 80.13 62.78 C 80.13 62.78 88.60 57.54 105.72 60.98 L 106.02 66.11 L 80.13 62.78 Z"
                  fill="#ffe5b0" fill-opacity="0.47" fill-rule="nonzero" group-id="2,17" node-id="238" stroke="none"
                  target-height="8.571999" target-width="25.890999" target-x="80.126" target-y="57.543" />
                <path
                  d="M 53.68 73.21 C 56.82 71.62 60.30 69.50 63.29 67.56 C 56.74 66.94 55.72 64.90 55.72 64.90 L 55.71 64.89 C 55.39 64.83 55.07 64.77 54.74 64.70 C 54.74 64.70 56.88 65.64 52.28 67.42 C 47.70 69.19 46.20 77.00 53.68 73.21 Z"
                  fill="#d6c093" fill-opacity="0.47" fill-rule="nonzero" group-id="2,17" node-id="240" stroke="none"
                  target-height="12.299004" target-width="17.092" target-x="46.199" target-y="64.698" />
                <path d="M 83.39 61.41 C 83.39 61.41 95.97 61.44 105.87 63.52 L 106.02 66.11 L 83.39 61.41 Z"
                  fill="#d6c093" fill-opacity="0.19739999" fill-rule="nonzero" group-id="2,17,32" node-id="244"
                  stroke="none" target-height="4.7039986" target-width="22.632996" target-x="83.385" target-y="61.411" />
                <path
                  d="M 77.60 60.91 C 77.60 60.91 66.07 59.97 71.83 67.30 C 77.60 74.63 106.02 90.00 106.02 90.00 L 106.02 66.11 C 106.02 66.11 85.72 60.91 77.60 60.91 Z"
                  fill="#d6c093" fill-opacity="0.47" fill-rule="nonzero" group-id="2,17,33" node-id="249" stroke="none"
                  target-height="30.038998" target-width="39.952995" target-x="66.066" target-y="59.966" />
                <path
                  d="M 38.72 82.90 C 38.72 82.90 56.57 79.19 64.94 67.68 C 64.94 67.68 60.21 77.14 38.72 86.83 L 38.72 82.90 Z"
                  fill="#d6c093" fill-opacity="0.1269" fill-rule="nonzero" group-id="2,17,34" node-id="254" stroke="none"
                  target-height="19.150002" target-width="26.218002" target-x="38.72" target-y="67.684" />
                <path d="M 73.11 68.70 C 73.11 68.70 89.30 81.64 92.44 90.00 L 106.02 90.00 L 73.11 68.70 Z"
                  fill="#d6c093" fill-opacity="0.1175" fill-rule="nonzero" group-id="2,17,35" node-id="259" stroke="none"
                  target-height="21.306" target-width="32.913994" target-x="73.105" target-y="68.698" />
                <path
                  d="M 75.51 69.30 C 68.77 60.85 82.26 61.94 82.26 61.94 C 83.71 61.94 85.27 61.95 86.86 61.95 C 83.28 61.34 79.94 60.91 77.60 60.91 C 77.60 60.91 66.07 59.97 71.83 67.30 C 74.39 70.55 81.39 75.38 88.40 79.75 C 83.17 76.33 78.11 72.56 75.51 69.30 Z M 105.55 65.99 L 105.55 89.70 C 105.55 89.70 104.88 89.36 103.73 88.75 C 105.17 89.54 106.02 90.00 106.02 90.00 L 106.02 66.11 C 106.02 66.11 105.85 66.07 105.55 65.99 Z"
                  fill="#c7b289" fill-opacity="0.47" fill-rule="nonzero" group-id="2,17,36" node-id="264" stroke="none"
                  target-height="30.035" target-width="39.952995" target-x="66.066" target-y="59.967" />
                <path
                  d="M 53.86 67.42 C 55.60 66.74 56.37 66.19 56.66 65.77 C 55.91 65.28 55.72 64.89 55.72 64.89 C 55.72 64.89 55.72 64.89 55.72 64.89 C 55.40 64.83 55.07 64.77 54.75 64.70 C 54.75 64.70 56.88 65.64 52.29 67.42 C 48.30 68.96 46.65 75.06 51.20 74.14 C 48.73 73.41 50.44 68.74 53.86 67.42 Z"
                  fill="#c7b289" fill-opacity="0.47" fill-rule="nonzero" group-id="2,17,37" node-id="269" stroke="none"
                  target-height="10.359001" target-width="10.234001" target-x="46.645" target-y="64.697" />
              </g>
            </g>
            <g node-id="501">
              <g node-id="516">
                <path d="M 6.71 194.41 L 6.71 151.02 L 75.19 151.02 L 75.19 219.49 L 31.79 219.49 Z" fill="#fafffa"
                  fill-rule="nonzero" group-id="3,18" node-id="278" stroke="none" target-height="68.47099"
                  target-width="68.474" target-x="6.711" target-y="151.016" />
                <path
                  d="M 75.19 220.99 L 31.79 220.99 C 31.39 220.99 31.01 220.83 30.73 220.55 L 5.65 195.47 C 5.37 195.19 5.21 194.81 5.21 194.41 L 5.21 151.02 C 5.21 150.19 5.88 149.52 6.71 149.52 L 75.19 149.52 C 76.02 149.52 76.69 150.19 76.69 151.02 L 76.69 219.49 C 76.69 220.31 76.01 220.99 75.19 220.99 Z M 32.41 217.99 L 73.68 217.99 L 73.68 152.51 L 8.21 152.51 L 8.21 193.79 L 32.41 217.99 Z"
                  fill="#ccccde" fill-rule="nonzero" group-id="3,18" node-id="280" stroke="none" target-height="71.47099"
                  target-width="71.474" target-x="5.212" target-y="149.516" />
              </g>
              <g node-id="517">
                <path d="M 6.71 194.41 L 31.79 194.41 L 31.79 219.49 Z" fill="#edffeb" fill-rule="nonzero" group-id="3,19"
                  node-id="285" stroke="none" target-height="25.074005" target-width="25.074999" target-x="6.711"
                  target-y="194.413" />
                <path
                  d="M 31.79 220.99 C 31.40 220.99 31.01 220.84 30.73 220.55 L 5.65 195.47 C 5.22 195.04 5.09 194.40 5.33 193.84 C 5.56 193.28 6.11 192.91 6.71 192.91 L 31.79 192.91 C 32.62 192.91 33.29 193.59 33.29 194.41 L 33.29 219.49 C 33.29 220.09 32.92 220.64 32.36 220.87 C 32.17 220.95 31.98 220.99 31.79 220.99 Z M 10.33 195.91 L 30.29 215.87 L 30.29 195.91 L 10.33 195.91 Z"
                  fill="#ccccde" fill-rule="nonzero" group-id="3,19" node-id="287" stroke="none" target-height="28.074005"
                  target-width="28.193998" target-x="5.093" target-y="192.913" />
              </g>
            </g>
            <g node-id="502">
              <g node-id="518">
                <g node-id="536">
                  <path
                    d="M 97.20 176.82 L 94.49 176.82 C 94.49 176.82 95.72 177.09 97.20 176.82 Z M 138.11 169.34 L 138.11 160.16 L 102.33 160.16 L 102.33 168.98 C 102.33 174.76 99.47 176.42 97.20 176.82 L 102.33 176.82 L 102.33 179.27 L 138.11 179.27 L 138.11 176.82 L 145.95 176.82 C 138.78 176.82 138.15 170.87 138.11 169.34 Z"
                    fill="#f0f0ff" fill-rule="nonzero" group-id="4,20,38" node-id="295" stroke="none"
                    target-height="19.110992" target-width="51.462997" target-x="94.491" target-y="160.16" />
                  <path
                    d="M 139.61 180.77 L 100.83 180.77 L 100.83 178.32 L 97.33 178.32 C 96.85 178.40 96.34 178.44 95.84 178.44 C 95.84 178.44 95.84 178.44 95.84 178.44 C 94.77 178.44 92.99 178.44 92.99 176.82 L 92.99 175.32 L 97.05 175.32 C 99.56 174.82 100.83 172.69 100.83 168.98 L 100.83 158.66 L 139.61 158.66 L 139.61 169.34 C 139.66 171.11 140.38 175.32 145.95 175.32 L 145.95 178.32 L 139.61 178.32 L 139.61 180.77 Z M 103.83 177.77 L 136.61 177.77 L 136.61 175.32 L 138.74 175.32 C 137.31 173.61 136.67 171.41 136.61 169.38 L 136.61 161.66 L 103.83 161.66 L 103.83 168.98 C 103.83 171.90 103.16 173.92 102.20 175.32 L 103.83 175.32 L 103.83 177.77 Z M 133.09 174.77 C 132.26 174.77 131.59 174.10 131.59 173.27 C 131.59 172.44 132.26 171.77 133.09 171.77 C 133.91 171.77 134.59 172.44 134.59 173.27 C 134.59 174.10 133.91 174.77 133.09 174.77 Z"
                    fill="#6e6e96" fill-rule="nonzero" group-id="4,20,38" node-id="297" stroke="none"
                    target-height="22.110992" target-width="52.959007" target-x="92.992" target-y="158.66" />
                </g>
                <g node-id="537">
                  <path d="M 94.49 176.82 L 145.95 176.82 L 145.95 181.73 L 94.49 181.73 Z" fill="#f2f2f2"
                    fill-rule="nonzero" group-id="4,20,39" node-id="302" stroke="none" target-height="4.903"
                    target-width="51.462006" target-x="94.491" target-y="176.823" />
                  <path
                    d="M 145.95 183.23 L 94.49 183.23 C 93.66 183.23 92.99 182.56 92.99 181.73 L 92.99 176.82 C 92.99 176.00 93.66 175.32 94.49 175.32 L 145.95 175.32 C 146.78 175.32 147.45 176.00 147.45 176.82 L 147.45 181.73 C 147.45 182.56 146.78 183.23 145.95 183.23 Z M 95.99 180.23 L 144.45 180.23 L 144.45 178.32 L 95.99 178.32 L 95.99 180.23 Z"
                    fill="#6e6e96" fill-rule="nonzero" group-id="4,20,39" node-id="304" stroke="none"
                    target-height="7.903" target-width="54.462006" target-x="92.991" target-y="175.324" />
                </g>
                <g node-id="538">
                  <path
                    d="M 57.49 146.93 L 57.49 68.02 C 57.49 62.63 61.90 58.22 67.29 58.22 L 173.16 58.22 C 178.55 58.22 182.96 62.63 182.96 68.02 L 182.96 146.93"
                    fill="#bbc0d9" fill-rule="nonzero" group-id="4,20,40" node-id="309" stroke="none"
                    target-height="88.711" target-width="125.47099" target-x="57.487" target-y="58.216" />
                </g>
                <path d="M 64.59 65.58 L 175.13 65.58 L 175.13 132.63 L 64.59 132.63 Z" fill="#bddcff" fill-rule="nonzero"
                  group-id="4,20" node-id="312" stroke="none" target-height="67.045006" target-width="110.537"
                  target-x="64.593" target-y="65.581" />
                <path
                  d="M 182.96 139.09 L 182.96 150.36 C 182.96 155.75 178.54 160.16 173.15 160.16 L 67.29 160.16 C 61.90 160.16 57.49 155.75 57.49 150.36 L 57.49 139.09 L 182.96 139.09 Z"
                  fill="#f0f0ff" fill-rule="nonzero" group-id="4,20,41" node-id="316" stroke="none"
                  target-height="21.074005" target-width="125.47099" target-x="57.487" target-y="139.086" />
                <path d="M 64.59 65.58 L 175.13 65.58 L 175.13 70.08 L 64.59 70.08 Z" fill="#6e6e96" fill-opacity="0.15"
                  fill-rule="nonzero" group-id="4,20,42" node-id="321" stroke="none" target-height="4.503998"
                  target-width="110.537" target-x="64.593" target-y="65.581" />
                <path
                  d="M 172.74 57.27 L 66.88 57.27 C 61.48 57.27 57.07 61.68 57.07 67.07 L 57.07 71.20 C 57.07 65.81 61.48 61.40 66.88 61.40 L 172.74 61.40 C 178.13 61.40 182.54 65.81 182.54 71.20 L 182.54 67.07 C 182.54 61.68 178.13 57.27 172.74 57.27 Z"
                  fill="#d5dbf7" fill-rule="nonzero" group-id="4,20" node-id="324" stroke="none" target-height="13.937"
                  target-width="125.472" target-x="57.073" target-y="57.268" />
                <path
                  d="M 173.16 161.66 L 67.29 161.66 C 61.06 161.66 55.99 156.59 55.99 150.36 L 55.99 137.59 L 184.46 137.59 L 184.46 150.36 C 184.46 156.59 179.39 161.66 173.16 161.66 Z M 58.99 140.59 L 58.99 150.36 C 58.99 154.94 62.71 158.66 67.29 158.66 L 173.16 158.66 C 177.73 158.66 181.46 154.94 181.46 150.36 L 181.46 140.59 L 58.99 140.59 Z"
                  fill="#6e6e96" fill-rule="nonzero" group-id="4,20,43" node-id="328" stroke="none"
                  target-height="24.074005" target-width="128.471" target-x="55.987" target-y="137.586" />
                <path
                  d="M 184.46 146.93 L 181.46 146.93 L 181.46 68.02 C 181.46 63.44 177.73 59.72 173.15 59.72 L 67.29 59.72 C 62.71 59.72 58.99 63.44 58.99 68.02 L 58.99 146.93 L 55.99 146.93 L 55.99 68.02 C 55.99 61.79 61.06 56.72 67.29 56.72 L 173.15 56.72 C 179.39 56.72 184.46 61.79 184.46 68.02 L 184.46 146.93 Z"
                  fill="#6e6e96" fill-rule="nonzero" group-id="4,20,44" node-id="333" stroke="none" target-height="90.211"
                  target-width="128.47101" target-x="55.986" target-y="56.716" />
                <path
                  d="M 173.16 155.41 L 67.29 155.41 C 61.90 155.41 57.49 151.00 57.49 145.60 L 57.49 150.36 C 57.49 155.75 61.90 160.16 67.29 160.16 L 173.16 160.16 C 178.55 160.16 182.96 155.75 182.96 150.36 L 182.96 145.60 C 182.96 151.00 178.55 155.41 173.16 155.41 Z"
                  fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="4,20,45" node-id="338" stroke="none"
                  target-height="14.559006" target-width="125.47099" target-x="57.487" target-y="145.603" />
                <path d="M 57.49 135.16 L 182.96 135.16 L 182.96 139.09 L 57.49 139.09 Z" fill="#6e6e96"
                  fill-opacity="0.15" fill-rule="nonzero" group-id="4,20,46" node-id="343" stroke="none"
                  target-height="3.925003" target-width="125.47099" target-x="57.487" target-y="135.161" />
                <path d="M 102.33 160.16 L 138.11 160.16 L 138.11 166.42 L 102.33 166.42 Z" fill="#6e6e96"
                  fill-opacity="0.15" fill-rule="nonzero" group-id="4,20,47" node-id="348" stroke="none"
                  target-height="6.2579956" target-width="35.775993" target-x="102.333" target-y="160.16" />
                <path d="M 131.36 176.82 L 145.95 176.82 L 145.95 181.73 L 131.36 181.73 Z" fill="#6e6e96"
                  fill-opacity="0.15" fill-rule="nonzero" group-id="4,20,48" node-id="353" stroke="none"
                  target-height="4.903" target-width="14.595001" target-x="131.358" target-y="176.823" />
                <path d="M 108.92 132.06 L 174.50 66.48 L 174.50 88.56 L 131.00 132.06 Z" fill="#deefff"
                  fill-opacity="0.31" fill-rule="nonzero" group-id="4,20,49" node-id="358" stroke="none"
                  target-height="65.58501" target-width="65.58199" target-x="108.917" target-y="66.476" />
                <path d="M 174.50 88.56 L 131.00 132.06 L 174.50 132.06 Z" fill="#ffffff" fill-opacity="0.31"
                  fill-rule="nonzero" group-id="4,20,50" node-id="363" stroke="none" target-height="43.496002"
                  target-width="43.494995" target-x="131.004" target-y="88.565" />
                <path
                  d="M 123.92 150.56 L 115.64 150.56 C 114.82 150.56 114.14 149.88 114.14 149.06 C 114.14 148.23 114.82 147.56 115.64 147.56 L 123.92 147.56 C 124.74 147.56 125.42 148.23 125.42 149.06 C 125.42 149.88 124.74 150.56 123.92 150.56 Z"
                  fill="#6e6e96" fill-rule="nonzero" group-id="4,20" node-id="366" stroke="none" target-height="3"
                  target-width="11.270004" target-x="114.145" target-y="147.555" />
                <path d="M 64.59 92.83 L 87.33 70.08 L 121.44 70.08 L 65.11 126.42 Z" fill="#ffffff" fill-opacity="0.17"
                  fill-rule="nonzero" group-id="4,20,51" node-id="370" stroke="none" target-height="56.33"
                  target-width="56.841995" target-x="64.593" target-y="70.085" />
                <path
                  d="M 175.13 134.13 L 64.59 134.13 C 63.76 134.13 63.09 133.45 63.09 132.63 L 63.09 65.58 C 63.09 64.75 63.76 64.08 64.59 64.08 L 175.13 64.08 C 175.96 64.08 176.63 64.75 176.63 65.58 L 176.63 132.63 C 176.63 133.45 175.96 134.13 175.13 134.13 Z M 66.09 131.13 L 173.63 131.13 L 173.63 67.08 L 66.09 67.08 L 66.09 131.13 Z"
                  fill="#6e6e96" fill-rule="nonzero" group-id="4,20" node-id="373" stroke="none" target-height="70.045006"
                  target-width="113.537" target-x="63.093" target-y="64.081" />
              </g>
              <g node-id="519">
                <path
                  d="M 76.88 175.90 C 76.88 179.00 74.34 181.55 71.23 181.55 L 46.17 181.55 C 43.06 181.55 40.52 179.00 40.52 175.90 L 40.52 121.33 C 40.52 118.23 43.06 115.68 46.17 115.68 L 71.23 115.68 C 74.34 115.68 76.88 118.23 76.88 121.33 L 76.88 175.90 L 76.88 175.90 L 76.88 175.90 Z"
                  fill="#f0f0ff" fill-rule="nonzero" group-id="4,21" node-id="378" stroke="none" target-height="65.866005"
                  target-width="36.369003" target-x="40.515" target-y="115.682" />
                <path
                  d="M 76.88 175.90 C 76.88 179.00 74.34 181.55 71.23 181.55 L 46.17 181.55 C 43.06 181.55 40.52 179.00 40.52 175.90 L 40.52 121.33 C 40.52 118.23 43.06 115.68 46.17 115.68 L 71.23 115.68 C 74.34 115.68 76.88 118.23 76.88 121.33 L 76.88 175.90 L 76.88 175.90 L 76.88 175.90 Z"
                  fill="#ffffff" fill-rule="nonzero" group-id="4,21" node-id="380" stroke="none" target-height="65.866005"
                  target-width="36.369003" target-x="40.515" target-y="115.682" />
                <path d="M 40.52 122.88 L 76.88 122.88 L 76.88 173.80 L 40.52 173.80 Z" fill="#bddcff" fill-rule="nonzero"
                  group-id="4,21" node-id="382" stroke="none" target-height="50.914" target-width="36.368004"
                  target-x="40.515" target-y="122.884" />
                <g node-id="550">
                  <path d="M 42.20 173.80 L 76.88 139.11 L 76.88 150.80 L 53.88 173.80 Z" fill="#deefff"
                    fill-opacity="0.49" fill-rule="nonzero" group-id="4,21,52" node-id="386" stroke="none"
                    target-height="34.684006" target-width="34.685" target-x="42.198" target-y="139.114" />
                </g>
                <g node-id="551">
                  <path d="M 76.88 150.80 L 53.88 173.80 L 76.88 173.80 Z" fill="#ffffff" fill-opacity="0.4"
                    fill-rule="nonzero" group-id="4,21,53" node-id="391" stroke="none" target-height="23.001999"
                    target-width="23.003002" target-x="53.88" target-y="150.796" />
                </g>
                <path d="M 40.52 120.94 L 76.88 120.94 L 76.88 123.94 L 40.52 123.94 Z" fill="#6e6e96" fill-rule="nonzero"
                  group-id="4,21" node-id="394" stroke="none" target-height="3" target-width="36.368004" target-x="40.515"
                  target-y="120.938" />
                <path d="M 40.52 172.30 L 76.88 172.30 L 76.88 175.30 L 40.52 175.30 Z" fill="#6e6e96" fill-rule="nonzero"
                  group-id="4,21" node-id="396" stroke="none" target-height="3" target-width="36.368004" target-x="40.515"
                  target-y="172.298" />
                <path
                  d="M 61.15 120.12 L 56.25 120.12 C 55.69 120.12 55.25 119.68 55.25 119.12 C 55.25 118.57 55.69 118.12 56.25 118.12 L 61.15 118.12 C 61.71 118.12 62.15 118.57 62.15 119.12 C 62.15 119.68 61.71 120.12 61.15 120.12 Z"
                  fill="#6e6e96" fill-rule="nonzero" group-id="4,21" node-id="398" stroke="none" target-height="2"
                  target-width="6.908001" target-x="55.246" target-y="118.123" />
                <path
                  d="M 58.70 180.70 C 57.07 180.70 55.75 179.37 55.75 177.75 C 55.75 176.12 57.07 174.79 58.70 174.79 C 60.33 174.79 61.65 176.12 61.65 177.75 C 61.65 179.37 60.33 180.70 58.70 180.70 Z M 58.70 176.79 C 58.17 176.79 57.75 177.22 57.75 177.75 C 57.75 178.27 58.17 178.70 58.70 178.70 C 59.22 178.70 59.65 178.27 59.65 177.75 C 59.65 177.22 59.23 176.79 58.70 176.79 Z"
                  fill="#6e6e96" fill-rule="nonzero" group-id="4,21" node-id="400" stroke="none" target-height="5.9039917"
                  target-width="5.903" target-x="55.748" target-y="174.794" />
                <path d="M 76.88 122.44 L 40.52 122.44 L 40.52 173.80 L 42.20 173.80 L 42.20 124.16 L 76.88 124.16 Z"
                  fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="4,21,54" node-id="404" stroke="none"
                  target-height="51.36" target-width="36.368004" target-x="40.515" target-y="122.438" />
                <path d="M 40.52 120.16 L 76.88 120.16 L 76.88 121.63 L 40.52 121.63 Z" fill="#6e6e96" fill-opacity="0.15"
                  fill-rule="nonzero" group-id="4,21,55" node-id="409" stroke="none" target-height="1.4790039"
                  target-width="36.368004" target-x="40.515" target-y="120.155" />
                <path
                  d="M 71.48 178.68 L 46.42 178.68 C 43.31 178.68 40.77 177.15 40.77 173.03 L 40.77 174.42 C 40.77 179.54 43.31 180.07 46.42 180.07 L 71.48 180.07 C 74.59 180.07 77.14 178.53 77.14 174.42 L 77.14 174.42 L 77.14 173.03 L 77.14 173.03 C 77.14 176.14 74.59 178.68 71.48 178.68 Z"
                  fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="4,21,56" node-id="414" stroke="none"
                  target-height="7.0399933" target-width="36.369003" target-x="40.767" target-y="173.031" />
                <path d="M 40.90 135.14 L 49.59 124.75 L 65.17 124.75 L 41.13 150.49 Z" fill="#ffffff" fill-opacity="0.17"
                  fill-rule="nonzero" group-id="4,21,57" node-id="419" stroke="none" target-height="25.743996"
                  target-width="24.276997" target-x="40.896" target-y="124.749" />
                <path d="M 72.67 124.75 L 41.63 155.78 L 41.60 160.22 L 77.07 124.75 Z" fill="#ffffff" fill-opacity="0.2"
                  fill-rule="nonzero" group-id="4,21,58" node-id="424" stroke="none" target-height="35.474007"
                  target-width="35.473" target-x="41.598" target-y="124.749" />
                <path
                  d="M 71.23 183.05 L 46.17 183.05 C 41.22 183.05 39.02 180.84 39.02 175.90 L 39.02 121.34 C 39.02 116.39 41.22 114.18 46.17 114.18 L 71.23 114.18 C 76.18 114.18 78.38 116.39 78.38 121.34 L 78.38 175.90 C 78.38 180.84 76.18 183.05 71.23 183.05 Z M 46.17 117.18 C 42.87 117.18 42.02 118.04 42.02 121.34 L 42.02 175.90 C 42.02 179.20 42.87 180.05 46.17 180.05 L 71.23 180.05 C 74.53 180.05 75.38 179.19 75.38 175.90 L 75.38 121.34 C 75.38 118.04 74.53 117.18 71.23 117.18 L 46.17 117.18 Z"
                  fill="#6e6e96" fill-rule="nonzero" group-id="4,21" node-id="427" stroke="none" target-height="68.866"
                  target-width="39.369003" target-x="39.015" target-y="114.183" />
              </g>
            </g>
            <g node-id="503">
              <path
                d="M 219.84 176.16 C 219.84 179.26 217.30 181.81 214.19 181.81 L 171.97 181.81 C 168.87 181.81 166.32 179.26 166.32 172.30 L 166.32 102.31 C 166.32 103.06 168.87 100.51 171.97 100.51 L 214.19 100.51 C 217.30 100.51 219.84 103.06 219.84 102.31 L 219.84 172.30 L 219.84 176.16 L 219.84 176.16 Z"
                fill="#f0f0ff" fill-rule="nonzero" group-id="5" node-id="433" stroke="none" target-height="81.297"
                target-width="53.524994" target-x="166.32" target-y="100.513" />
              <path
                d="M 219.84 176.16 C 219.84 179.26 217.30 181.81 214.19 181.81 L 171.97 181.81 C 168.87 181.81 166.32 179.26 166.32 172.30 L 166.32 102.31 C 166.32 103.06 168.87 100.51 171.97 100.51 L 214.19 100.51 C 217.30 100.51 219.84 103.06 219.84 102.31 L 219.84 172.30 L 219.84 176.16 L 219.84 176.16 Z"
                fill="#ffffff" fill-rule="nonzero" group-id="5" node-id="435" stroke="none" target-height="81.297"
                target-width="53.524994" target-x="166.32" target-y="100.513" />
              <path d="M 166.32 107.72 L 219.84 107.72 L 219.84 170.20 L 166.32 170.20 Z" fill="#bddcff"
                fill-rule="nonzero" group-id="5" node-id="437" stroke="none" target-height="62.487" target-width="53.526"
                target-x="166.318" target-y="107.716" />
              <g node-id="520">
                <path d="M 168.00 170.20 L 219.84 126.50 L 219.84 146.24 L 190.01 170.20 Z" fill="#deefff"
                  fill-opacity="0.49" fill-rule="nonzero" group-id="5,22" node-id="441" stroke="none"
                  target-height="43.698006" target-width="51.843002" target-x="168.002" target-y="126.505" />
              </g>
              <g node-id="521">
                <path d="M 219.84 146.24 L 190.01 170.20 L 219.84 170.20 Z" fill="#ffffff" fill-opacity="0.4"
                  fill-rule="nonzero" group-id="5,23" node-id="446" stroke="none" target-height="23.96701"
                  target-width="29.837997" target-x="190.007" target-y="146.236" />
              </g>
              <path d="M 166.32 105.77 L 219.84 105.77 L 219.84 108.77 L 166.32 108.77 Z" fill="#6e6e96"
                fill-rule="nonzero" group-id="5" node-id="449" stroke="none" target-height="3" target-width="53.527008"
                target-x="166.318" target-y="105.771" />
              <path d="M 166.32 168.70 L 219.84 168.70 L 219.84 171.70 L 166.32 171.70 Z" fill="#6e6e96"
                fill-rule="nonzero" group-id="5" node-id="451" stroke="none" target-height="3" target-width="53.527008"
                target-x="166.318" target-y="168.703" />
              <path
                d="M 194.83 179.03 C 193.20 179.03 191.88 177.71 191.88 176.08 C 191.88 174.45 193.20 173.13 194.83 173.13 C 196.45 173.13 197.78 174.45 197.78 176.08 C 197.78 177.71 196.45 179.03 194.83 179.03 Z M 194.83 175.13 C 194.30 175.13 193.88 175.55 193.88 176.08 C 193.88 176.60 194.30 177.03 194.83 177.03 C 195.35 177.03 195.78 176.60 195.78 176.08 C 195.78 175.55 195.35 175.13 194.83 175.13 Z"
                fill="#6e6e96" fill-rule="nonzero" group-id="5" node-id="453" stroke="none" target-height="5.904007"
                target-width="5.903" target-x="191.875" target-y="173.127" />
              <path d="M 219.84 107.27 L 166.32 107.27 L 166.32 170.20 L 168.00 170.20 L 168.00 108.99 L 219.84 108.99 Z"
                fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="5,24" node-id="457" stroke="none"
                target-height="62.932" target-width="53.527008" target-x="166.318" target-y="107.271" />
              <path d="M 166.32 104.99 L 219.84 104.99 L 219.84 106.47 L 166.32 106.47 Z" fill="#6e6e96"
                fill-opacity="0.15" fill-rule="nonzero" group-id="5,25" node-id="462" stroke="none"
                target-height="1.4790039" target-width="53.526" target-x="166.318" target-y="104.988" />
              <path
                d="M 214.44 178.95 L 172.22 178.95 C 169.12 178.95 166.57 173.55 166.57 169.43 L 166.57 170.82 C 166.57 175.94 169.12 180.33 172.22 180.33 L 214.44 180.33 C 217.55 180.33 220.09 174.94 220.09 170.82 L 220.10 170.82 L 220.10 169.43 L 220.09 169.43 C 220.10 172.54 217.55 178.95 214.44 178.95 Z"
                fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="5,26" node-id="467" stroke="none"
                target-height="10.899002" target-width="53.526993" target-x="166.57" target-y="169.433" />
              <path d="M 166.25 124.15 L 185.71 108.99 L 205.16 108.99 L 166.49 139.50 Z" fill="#ffffff"
                fill-opacity="0.17" fill-rule="nonzero" group-id="5,27" node-id="472" stroke="none"
                target-height="30.51101" target-width="38.905" target-x="166.253" target-y="108.992" />
              <path
                d="M 214.19 183.31 L 171.97 183.31 C 165.93 183.31 164.82 179.60 164.82 172.30 L 164.82 104.24 C 164.82 102.43 166.31 99.01 171.97 99.01 L 214.19 99.01 C 220.13 99.01 221.34 103.14 221.34 104.24 L 221.34 176.16 C 221.34 181.10 219.14 183.31 214.19 183.31 Z M 171.97 102.01 C 168.02 102.01 167.83 104.03 167.82 104.26 L 167.82 172.30 C 167.82 180.31 169.38 180.31 171.97 180.31 L 214.19 180.31 C 217.49 180.31 218.34 179.46 218.34 176.16 L 218.34 104.24 C 218.32 104.10 217.96 102.01 214.19 102.01 L 171.97 102.01 Z"
                fill="#6e6e96" fill-rule="nonzero" group-id="5" node-id="475" stroke="none" target-height="84.297005"
                target-width="56.524994" target-x="164.82" target-y="99.014" />
            </g>
            <g node-id="504">
              <g node-id="526">
                <path
                  d="M 222.14 37.07 C 222.84 34.93 225.03 32.30 227.00 31.23 L 227.01 31.22 C 228.99 30.15 228.99 28.40 227.01 27.32 L 227.00 27.32 C 225.03 26.25 222.73 23.83 221.89 21.95 C 221.06 20.07 219.70 20.07 218.87 21.95 C 218.03 23.83 215.73 26.25 213.75 27.32 L 213.74 27.32 C 211.76 28.40 211.76 30.15 213.74 31.22 L 213.75 31.23 C 215.73 32.30 217.92 34.93 218.62 37.07 L 219.11 38.58 C 219.81 40.72 220.94 40.72 221.65 38.58 L 222.14 37.07 Z"
                  fill="#7fe5ff" fill-rule="nonzero" group-id="6,28" node-id="481" stroke="none" target-height="20.652"
                  target-width="17.235992" target-x="211.757" target-y="20.07" />
              </g>
              <g node-id="527">
                <path
                  d="M 67.97 20.81 C 68.47 19.30 70.01 17.45 71.41 16.69 L 71.42 16.69 C 72.81 15.93 72.81 14.69 71.42 13.93 L 71.41 13.93 C 70.01 13.17 68.39 11.46 67.80 10.13 C 67.21 8.81 66.25 8.81 65.66 10.13 C 65.08 11.46 63.45 13.17 62.05 13.93 L 62.05 13.93 C 60.65 14.69 60.65 15.93 62.05 16.69 L 62.05 16.69 C 63.45 17.45 65.00 19.30 65.49 20.82 L 65.84 21.88 C 66.33 23.40 67.14 23.40 67.63 21.88 L 67.97 20.81 Z"
                  fill="#ffb0b8" fill-rule="nonzero" group-id="6,29" node-id="486" stroke="none" target-height="14.589999"
                  target-width="12.167004" target-x="60.647" target-y="8.807" />
              </g>
              <path
                d="M 8.40 86.00 C 8.99 84.18 10.86 81.94 12.54 81.04 L 12.55 81.03 C 14.23 80.12 14.23 78.63 12.55 77.72 L 12.54 77.71 C 10.86 76.80 8.90 74.74 8.19 73.14 C 7.49 71.54 6.33 71.54 5.62 73.14 C 4.91 74.74 2.95 76.80 1.27 77.71 L 1.26 77.72 C -0.42 78.62 -0.42 80.12 1.26 81.03 L 1.27 81.04 C 2.95 81.95 4.82 84.19 5.41 86.00 L 5.83 87.29 C 6.42 89.11 7.39 89.11 7.98 87.29 L 8.40 86.00 Z"
                fill="#9adfc0" fill-rule="nonzero" group-id="6,30" node-id="491" stroke="none" target-height="17.569"
                target-width="14.655" target-x="-0.422" target-y="71.544" />
            </g>
            <path
              d="M 130.56 225.13 C 131.21 223.13 133.27 220.67 135.12 219.66 L 135.13 219.66 C 136.99 218.66 136.99 217.01 135.13 216.01 L 135.12 216.00 C 133.27 215.00 131.11 212.74 130.33 210.98 C 129.56 209.22 128.28 209.22 127.50 210.98 C 126.72 212.74 124.57 215.00 122.72 216.01 L 122.71 216.01 C 120.85 217.01 120.85 218.66 122.71 219.66 L 122.72 219.66 C 124.57 220.67 126.62 223.13 127.27 225.14 L 127.73 226.55 C 128.39 228.56 129.46 228.56 130.11 226.55 L 130.56 225.13 Z"
              fill="#ffbf00" fill-rule="nonzero" group-id="7" node-id="497" stroke="none" target-height="19.34401"
              target-width="16.132004" target-x="120.853" target-y="209.215" />
          </svg>
        </div>
        <p style="font-size: 14px;">新增客资数{{ addCustomerNum }}</p>
      </div>
      <div style="width: 30%;margin-left: 100px;">
        <Income5  :list5="list5" :times="times"></Income5>
      </div>
      <div style="width: 30%;margin-left: 100px;">
        <Income6 :list6="list3" :times="times"></Income6>
      </div>
    </div>


    <div class="title">定金分析 {{ handleGetTimeString(createTime && createTime.length > 0 ? createTime[0] : '') }} - {{ handleGetTimeString(createTime && createTime.length > 0 ? createTime[1] : '' ) }}</div>
    <div class="textbox">
      <div class="all">
        <div class="title" style="border-bottom: 1px solid #ccc;">新增定金数</div>
        <div class="item" style="height: 55%;">
          <span style="font-size: 24px; font-weight: bold;">{{ orderCustomerNum }}条</span>
          <svg height="80" node-id="1" sillyvg="true" template-height="243" template-width="249" version="1.1"
            viewBox="0 0 249 243" width="80" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs node-id="64"></defs>
            <g node-id="208">
              <path
                d="M 242.70 121.35 C 242.70 188.37 188.37 242.70 121.35 242.70 C 54.33 242.70 0.00 188.37 0.00 121.35 C -0.00 54.33 54.33 0.00 121.35 0.00 C 188.37 -0.00 242.70 54.33 242.70 121.35 Z"
                fill="#6e6e96" fill-opacity="0.12" fill-rule="nonzero" group-id="1" node-id="68" stroke="none"
                target-height="242.698" target-width="242.698" target-x="0" target-y="0" />
            </g>
            <g node-id="209">
              <path
                d="M 207.83 193.45 C 207.83 202.84 200.14 210.52 190.75 210.52 L 46.48 210.52 C 37.09 210.52 29.40 202.84 29.40 193.45 L 29.40 67.84 C 29.40 58.45 37.09 50.77 46.48 50.77 L 190.75 50.77 C 200.15 50.77 207.83 58.45 207.83 67.84 L 207.83 193.45 Z"
                fill="#bbbbc7" fill-rule="nonzero" group-id="2" node-id="73" stroke="none" target-height="159.75"
                target-width="178.427" target-x="29.401" target-y="50.77" />
              <path
                d="M 207.83 193.45 C 207.83 202.84 200.14 210.52 190.75 210.52 L 46.48 210.52 C 37.09 210.52 29.40 202.84 29.40 193.45 L 29.40 67.84 C 29.40 58.45 37.09 50.77 46.48 50.77 L 190.75 50.77 C 200.15 50.77 207.83 58.45 207.83 67.84 L 207.83 193.45 Z"
                fill="#bbbbc7" fill-rule="nonzero" group-id="2" node-id="75" stroke="none" target-height="159.75"
                target-width="178.427" target-x="29.401" target-y="50.77" />
            </g>
            <g node-id="210">
              <path
                d="M 190.75 50.77 L 46.48 50.77 C 37.09 50.77 29.40 58.45 29.40 67.84 L 29.40 74.34 C 29.40 64.95 37.09 57.27 46.48 57.27 L 190.75 57.27 C 200.15 57.27 207.83 64.95 207.83 74.34 L 207.83 67.84 C 207.83 58.45 200.15 50.77 190.75 50.77 Z"
                fill="#ffffff" fill-opacity="0.15" fill-rule="nonzero" group-id="3" node-id="80" stroke="none"
                target-height="23.574001" target-width="178.427" target-x="29.401" target-y="50.769" />
            </g>
            <g node-id="211">
              <path
                d="M 190.75 212.02 L 46.48 212.02 C 36.23 212.02 27.90 203.69 27.90 193.45 L 27.90 67.84 C 27.90 57.60 36.23 49.27 46.48 49.27 L 190.75 49.27 C 201.00 49.27 209.33 57.60 209.33 67.84 L 209.33 193.45 C 209.33 203.69 201.00 212.02 190.75 212.02 Z M 46.48 52.27 C 37.89 52.27 30.90 59.26 30.90 67.84 L 30.90 193.45 C 30.90 202.03 37.89 209.02 46.48 209.02 L 190.75 209.02 C 199.34 209.02 206.33 202.03 206.33 193.45 L 206.33 67.84 C 206.33 59.26 199.34 52.27 190.75 52.27 L 46.48 52.27 Z"
                fill="#6e6e96" fill-rule="nonzero" group-id="4" node-id="85" stroke="none" target-height="162.75099"
                target-width="181.427" target-x="27.901" target-y="49.27" />
              <path
                d="M 190.75 212.02 L 46.48 212.02 C 36.23 212.02 27.90 203.69 27.90 193.45 L 27.90 67.84 C 27.90 57.60 36.23 49.27 46.48 49.27 L 190.75 49.27 C 201.00 49.27 209.33 57.60 209.33 67.84 L 209.33 193.45 C 209.33 203.69 201.00 212.02 190.75 212.02 Z M 46.48 52.27 C 37.89 52.27 30.90 59.26 30.90 67.84 L 30.90 193.45 C 30.90 202.03 37.89 209.02 46.48 209.02 L 190.75 209.02 C 199.34 209.02 206.33 202.03 206.33 193.45 L 206.33 67.84 C 206.33 59.26 199.34 52.27 190.75 52.27 L 46.48 52.27 Z"
                fill="#6e6e96" fill-rule="nonzero" group-id="4" node-id="87" stroke="none" target-height="162.75099"
                target-width="181.427" target-x="27.901" target-y="49.27" />
            </g>
            <g node-id="212">
              <path d="M 45.70 159.85 L 191.89 159.85 L 191.89 175.35 L 45.70 175.35 Z" fill="#ffffff" fill-opacity="0.15"
                fill-rule="nonzero" group-id="5" node-id="92" stroke="none" target-height="15.5" target-width="146.194"
                target-x="45.698" target-y="159.849" />
            </g>
            <path
              d="M 219.57 192.49 L 17.66 192.49 C 17.66 192.49 23.36 210.52 34.86 210.52 C 46.36 210.52 202.37 210.52 202.37 210.52 C 202.37 210.52 213.67 208.71 219.57 192.49 Z"
              fill="#bbbbc7" fill-rule="nonzero" node-id="95" stroke="none" target-height="18.035004"
              target-width="201.907" target-x="17.661" target-y="192.485" />
            <path d="M 45.70 68.09 L 191.53 68.09 L 191.53 170.00 L 45.70 170.00 Z" fill="#a6d2ff" fill-rule="nonzero"
              node-id="97" stroke="none" target-height="101.909" target-width="145.834" target-x="45.698"
              target-y="68.091" />
            <path
              d="M 191.53 171.50 L 45.70 171.50 C 44.87 171.50 44.20 170.83 44.20 170.00 L 44.20 68.09 C 44.20 67.26 44.87 66.59 45.70 66.59 L 191.53 66.59 C 192.36 66.59 193.03 67.26 193.03 68.09 L 193.03 170.00 C 193.03 170.83 192.36 171.50 191.53 171.50 Z M 47.20 168.50 L 190.03 168.50 L 190.03 69.59 L 47.20 69.59 L 47.20 168.50 Z"
              fill="#6e6e96" fill-rule="nonzero" node-id="99" stroke="none" target-height="104.909" target-width="148.834"
              target-x="44.198" target-y="66.591" />
            <path d="M 45.70 68.09 L 191.53 68.09 L 191.53 74.85 L 45.70 74.85 Z" fill="#6e6e96" fill-opacity="0.15"
              fill-rule="nonzero" group-id="6" node-id="103" stroke="none" target-height="6.7579956"
              target-width="145.834" target-x="45.698" target-y="68.091" />
            <path
              d="M 62.20 169.56 L 62.20 39.25 C 62.20 35.23 65.48 31.94 69.50 31.94 L 168.54 31.94 C 172.56 31.94 175.85 35.23 175.85 39.25 L 175.85 169.56"
              fill="#ffffff" fill-rule="nonzero" group-id="7,20" node-id="110" stroke="none" target-height="137.62401"
              target-width="113.659004" target-x="62.195" target-y="31.941" />
            <path
              d="M 177.35 169.56 L 174.35 169.56 L 174.35 39.25 C 174.35 36.05 171.75 33.44 168.54 33.44 L 69.50 33.44 C 66.30 33.44 63.70 36.05 63.70 39.25 L 63.70 169.56 L 60.70 169.56 L 60.70 39.25 C 60.70 34.39 64.65 30.44 69.50 30.44 L 168.54 30.44 C 173.40 30.44 177.35 34.39 177.35 39.25 L 177.35 169.56 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="7,20" node-id="112" stroke="none" target-height="139.12401"
              target-width="116.659004" target-x="60.695" target-y="30.441" />
            <path
              d="M 62.20 169.56 L 62.20 39.25 C 62.20 35.23 65.48 31.94 69.50 31.94 L 168.54 31.94 C 172.56 31.94 175.85 35.23 175.85 39.25 L 175.85 169.56 L 62.20 169.56 Z"
              fill="#ffffff" fill-rule="nonzero" group-id="7,21" node-id="117" stroke="none" target-height="137.62401"
              target-width="113.659004" target-x="62.195" target-y="31.941" />
            <path
              d="M 177.35 171.06 L 60.70 171.06 L 60.70 39.25 C 60.70 34.39 64.65 30.44 69.50 30.44 L 168.54 30.44 C 173.40 30.44 177.35 34.39 177.35 39.25 L 177.35 171.06 Z M 63.70 168.06 L 174.35 168.06 L 174.35 39.25 C 174.35 36.05 171.75 33.44 168.54 33.44 L 69.50 33.44 C 66.30 33.44 63.70 36.05 63.70 39.25 L 63.70 168.06 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="7,21" node-id="119" stroke="none" target-height="140.62401"
              target-width="116.659004" target-x="60.695" target-y="30.441" />
            <path d="M 62.20 71.82 L 175.85 71.82 L 175.85 102.71 L 62.20 102.71 Z" fill="#b6e0c4" fill-rule="nonzero"
              group-id="8" node-id="125" stroke="none" target-height="30.891998" target-width="113.657005"
              target-x="62.195" target-y="71.819" />
            <path
              d="M 177.35 104.21 L 60.70 104.21 L 60.70 70.32 L 177.35 70.32 L 177.35 104.21 Z M 63.70 101.21 L 174.35 101.21 L 174.35 73.32 L 63.70 73.32 L 63.70 101.21 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="8" node-id="127" stroke="none" target-height="33.892"
              target-width="116.657005" target-x="60.695" target-y="70.319" />
            <path d="M 98.86 46.11 L 157.34 46.11 L 157.34 49.11 L 98.86 49.11 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="9" node-id="132" stroke="none" target-height="3" target-width="58.473007" target-x="98.864"
              target-y="46.113" />
            <path d="M 80.83 46.11 L 90.58 46.11 L 90.58 49.11 L 80.83 49.11 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="9" node-id="134" stroke="none" target-height="3" target-width="9.746002" target-x="80.833"
              target-y="46.113" />
            <path d="M 98.86 85.26 L 157.34 85.26 L 157.34 88.26 L 98.86 88.26 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="10" node-id="139" stroke="none" target-height="3" target-width="58.473007" target-x="98.864"
              target-y="85.261" />
            <path d="M 80.83 85.26 L 90.58 85.26 L 90.58 88.26 L 80.83 88.26 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="10" node-id="141" stroke="none" target-height="3" target-width="9.746002" target-x="80.833"
              target-y="85.261" />
            <path d="M 99.74 119.90 L 158.22 119.90 L 158.22 122.90 L 99.74 122.90 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="11" node-id="146" stroke="none" target-height="3" target-width="58.473" target-x="99.742"
              target-y="119.9" />
            <path d="M 81.71 119.90 L 91.46 119.90 L 91.46 122.90 L 81.71 122.90 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="11" node-id="148" stroke="none" target-height="3" target-width="9.746002" target-x="81.712"
              target-y="119.9" />
            <path d="M 99.74 129.35 L 158.22 129.35 L 158.22 132.35 L 99.74 132.35 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="12" node-id="153" stroke="none" target-height="3" target-width="58.473" target-x="99.742"
              target-y="129.349" />
            <path d="M 81.71 129.35 L 91.46 129.35 L 91.46 132.35 L 81.71 132.35 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="12" node-id="155" stroke="none" target-height="3" target-width="9.746002" target-x="81.712"
              target-y="129.349" />
            <path
              d="M 15.29 26.21 C 15.29 30.36 11.93 33.72 7.79 33.72 C 3.64 33.72 0.28 30.36 0.28 26.21 C 0.28 22.07 3.64 18.71 7.79 18.71 C 11.93 18.71 15.29 22.07 15.29 26.21 Z"
              fill="#77bd91" fill-rule="nonzero" node-id="158" stroke="none" target-height="15" target-width="15"
              target-x="0.285" target-y="18.715" />
            <path d="M 20.57 197.51 L 216.89 197.51 L 219.05 192.83 L 18.16 191.81 Z" fill="#ffffff" fill-opacity="0.25"
              fill-rule="nonzero" group-id="13" node-id="162" stroke="none" target-height="5.696991"
              target-width="200.891" target-x="18.161" target-y="191.813" />
            <path
              d="M 248.78 150.22 C 248.78 154.63 245.20 158.22 240.78 158.22 C 236.37 158.22 232.78 154.63 232.78 150.22 C 232.78 145.80 236.37 142.22 240.78 142.22 C 245.20 142.22 248.78 145.80 248.78 150.22 Z"
              fill="#ed8ede" fill-rule="nonzero" node-id="165" stroke="none" target-height="16" target-width="16"
              target-x="232.785" target-y="142.215" />
            <path
              d="M 110.78 17.71 C 110.78 20.20 108.77 22.21 106.28 22.21 C 103.80 22.21 101.78 20.20 101.78 17.71 C 101.78 15.23 103.80 13.21 106.28 13.21 C 108.77 13.21 110.78 15.23 110.78 17.71 Z"
              fill="#ffbf00" fill-rule="nonzero" node-id="167" stroke="none" target-height="9" target-width="9"
              target-x="101.785" target-y="13.215" />
            <path
              d="M 202.37 212.02 L 34.86 212.02 C 22.40 212.02 16.48 193.72 16.23 192.94 C 16.09 192.48 16.17 191.99 16.45 191.60 C 16.73 191.21 17.18 190.99 17.66 190.99 L 219.57 190.99 C 220.06 190.99 220.52 191.22 220.80 191.63 C 221.08 192.03 221.15 192.54 220.98 193.00 C 214.85 209.85 203.11 211.92 202.61 212.00 C 202.53 212.01 202.45 212.02 202.37 212.02 Z M 19.82 193.99 C 21.61 198.45 26.73 209.02 34.86 209.02 L 202.23 209.02 C 203.35 208.79 212.00 206.66 217.37 193.99 L 19.82 193.99 Z"
              fill="#6e6e96" fill-rule="nonzero" node-id="169" stroke="none" target-height="21.035004"
              target-width="205.05899" target-x="16.087" target-y="190.986" />
            <path
              d="M 202.87 205.08 C 202.87 205.08 46.86 205.08 35.36 205.08 C 29.18 205.08 24.67 201.31 21.83 197.84 L 18.16 197.84 C 18.16 197.84 23.86 210.85 35.36 210.85 C 46.86 210.85 202.87 210.85 202.87 210.85 C 202.87 210.85 214.17 209.54 220.07 197.84 L 216.08 197.84 C 210.15 204.23 202.87 205.08 202.87 205.08 Z"
              fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="14" node-id="173" stroke="none"
              target-height="13.011002" target-width="201.907" target-x="18.161" target-y="197.838" />
            <path d="M 29.40 185.85 L 207.83 185.85 L 207.83 192.49 L 29.40 192.49 Z" fill="#6e6e96" fill-opacity="0.15"
              fill-rule="nonzero" group-id="15" node-id="178" stroke="none" target-height="6.6369934"
              target-width="178.427" target-x="29.401" target-y="185.849" />
            <path d="M 99.74 139.35 L 125.89 139.35 L 125.89 142.35 L 99.74 142.35 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="16" node-id="183" stroke="none" target-height="3" target-width="26.150002" target-x="99.742"
              target-y="139.349" />
            <path d="M 81.71 139.35 L 91.46 139.35 L 91.46 142.35 L 81.71 142.35 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="16" node-id="185" stroke="none" target-height="3" target-width="9.746002" target-x="81.712"
              target-y="139.349" />
            <path d="M 99.74 148.80 L 141.89 148.80 L 141.89 151.80 L 99.74 151.80 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="17" node-id="190" stroke="none" target-height="3" target-width="42.15" target-x="99.742"
              target-y="148.797" />
            <path d="M 81.71 148.80 L 91.46 148.80 L 91.46 151.80 L 81.71 151.80 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="17" node-id="192" stroke="none" target-height="3" target-width="9.746002" target-x="81.712"
              target-y="148.797" />
            <path d="M 98.86 55.77 L 141.89 55.77 L 141.89 58.77 L 98.86 58.77 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="18" node-id="197" stroke="none" target-height="3" target-width="43.028" target-x="98.864"
              target-y="55.769" />
            <path d="M 80.83 55.77 L 90.58 55.77 L 90.58 58.77 L 80.83 58.77 Z" fill="#6e6e96" fill-rule="nonzero"
              group-id="18" node-id="199" stroke="none" target-height="3" target-width="9.746002" target-x="80.833"
              target-y="55.769" />
            <path d="M 99.89 192.35 L 140.89 192.35 L 140.89 199.60 L 99.89 199.60 Z" fill="#bbbbc7" fill-rule="nonzero"
              group-id="19" node-id="204" stroke="none" target-height="7.25" target-width="41.000008" target-x="99.893"
              target-y="192.349" />
            <path
              d="M 142.39 201.10 L 98.39 201.10 L 98.39 190.85 L 142.39 190.85 L 142.39 201.10 Z M 101.39 198.10 L 139.39 198.10 L 139.39 193.85 L 101.39 193.85 L 101.39 198.10 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="19" node-id="206" stroke="none" target-height="10.25"
              target-width="44.000008" target-x="98.393" target-y="190.849" />
          </svg>
        </div>
        <p style="font-size: 14px;">新增定金数{{ orderCustomerNum }}</p>
      </div>
      <div style="width: 30%;margin-left: 100px;">
        <Income5copy  :list5="list55" :times="times"></Income5copy>
      </div>
      <div style="width: 30%;margin-left: 100px;">
        <Income6copy :list6="list33" :times="times"></Income6copy>
      </div>
    </div>


    <div class="title">成单分析 {{ handleGetTimeString(createTime && createTime.length > 0 ? createTime[0] : '') }} - {{ handleGetTimeString(createTime && createTime.length > 0 ? createTime[1] : '' ) }}</div>
    <div class="textbox">
      <div class="all">
        <div class="title" style="border-bottom: 1px solid #ccc;">新增成单数</div>
        <div class="item" style="height: 55%;">
          <span style="font-size: 24px; font-weight: bold;">{{ turnover }}条</span>
          <svg height="80" node-id="1" sillyvg="true" template-height="251" template-width="256" version="1.1"
            viewBox="0 0 256 251" width="80" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs node-id="395"></defs>
            <g node-id="716">
              <path
                d="M 245.33 118.57 C 245.33 153.01 215.46 170.27 182.06 209.69 C 170.40 223.46 146.27 222.53 127.48 222.53 C 77.38 222.53 41.48 197.34 41.48 142.23 C 41.48 87.13 130.31 -4.34 171.58 24.07 C 195.27 40.37 245.33 34.88 245.33 118.57 Z"
                fill="#e6e3f7" fill-rule="nonzero" group-id="1" node-id="398" stroke="none" target-height="227.801"
                target-width="203.849" target-x="41.484" target-y="-4.344" />
              <path
                d="M 245.70 110.86 C 245.70 68.17 219.80 37.77 178.98 37.77 C 178.34 37.77 177.72 37.80 177.09 37.82 C 164.20 15.18 140.57 0.00 113.54 0.00 C 72.72 0.00 39.63 34.60 39.63 77.28 C 39.63 77.83 39.66 78.38 39.67 78.93 C 17.34 92.23 8.28 113.32 8.28 142.10 C 8.28 184.78 42.26 201.07 83.08 223.03 C 85.12 224.13 80.81 223.25 83.08 223.03 C 96.64 228.00 107.80 240.80 130.76 240.80 C 168.49 240.80 188.63 208.21 213.44 183.41 C 236.90 170.47 245.70 140.52 245.70 110.86 Z"
                fill="#e6e3f7" fill-rule="nonzero" group-id="1" node-id="400" stroke="none" target-height="240.803"
                target-width="237.427" target-x="8.277" target-y="0" />
            </g>
            <g node-id="717">
              <path d="M 179.38 188.41 L 134.26 152.38 L 107.33 175.31 L 135.22 219.79" fill="#ffdfd1" fill-rule="nonzero"
                group-id="2" node-id="405" stroke="none" target-height="67.41" target-width="72.054" target-x="107.328"
                target-y="152.385" />
              <path
                d="M 133.95 220.59 L 105.37 175.01 L 134.23 150.44 L 180.32 187.23 L 178.45 189.58 L 134.29 154.33 L 109.29 175.61 L 136.49 219.00 Z"
                fill="#6e6e96" fill-rule="nonzero" group-id="2" node-id="407" stroke="none" target-height="70.151"
                target-width="74.94899" target-x="105.369" target-y="150.441" />
            </g>
            <path d="M 117.04 110.29 C 117.04 110.29 119.40 116.42 123.06 118.34 L 124.74 116.50 L 117.04 110.29 Z"
              fill="#ffffff" fill-rule="nonzero" node-id="410" stroke="none" target-height="8.055"
              target-width="7.6949997" target-x="117.043" target-y="110.286" />
            <path
              d="M 22.53 81.15 C 21.35 81.15 20.16 80.74 19.21 79.89 C 17.15 78.06 16.96 74.89 18.80 72.83 C 33.76 55.99 53.39 44.81 75.56 40.50 C 93.67 36.98 112.35 38.42 129.60 44.65 C 132.20 45.58 133.54 48.45 132.61 51.05 C 131.67 53.64 128.80 54.99 126.21 54.05 C 110.66 48.44 93.80 47.15 77.47 50.32 C 57.47 54.20 39.77 64.29 26.27 79.47 C 25.28 80.58 23.91 81.15 22.53 81.15 Z"
              fill="#f59fb3" fill-rule="nonzero" group-id="3" node-id="413" stroke="none" target-height="44.168"
              target-width="116.58301" target-x="16.961" target-y="36.984" />
            <path
              d="M 10.74 122.07 C 10.26 122.07 9.78 122.00 9.30 121.86 C 6.66 121.07 5.15 118.28 5.94 115.64 C 16.09 81.61 44.02 56.27 78.85 49.50 C 118.93 41.71 159.40 60.33 179.54 95.82 C 180.91 98.22 180.06 101.27 177.66 102.63 C 175.26 104.00 172.21 103.15 170.85 100.75 C 152.82 69.00 116.62 52.35 80.76 59.32 C 49.60 65.38 24.60 88.05 15.53 118.50 C 14.88 120.67 12.89 122.07 10.74 122.07 Z"
              fill="#ffff75" fill-rule="nonzero" group-id="3" node-id="415" stroke="none" target-height="80.358"
              target-width="175.753" target-x="5.153" target-y="41.711" />
            <path
              d="M 15.56 137.09 C 15.35 137.09 15.13 137.08 14.91 137.05 C 12.17 136.70 10.24 134.19 10.59 131.45 C 11.18 126.90 12.14 122.35 13.45 117.93 C 14.23 115.28 17.01 113.77 19.66 114.55 C 22.31 115.34 23.82 118.12 23.04 120.77 C 21.88 124.67 21.03 128.70 20.51 132.73 C 20.19 135.25 18.04 137.09 15.56 137.09 Z"
              fill="#afeb75" fill-rule="nonzero" group-id="3" node-id="417" stroke="none" target-height="23.324997"
              target-width="13.581999" target-x="10.239" target-y="113.769" />
            <path
              d="M 24.18 109.66 C 23.40 109.66 22.61 109.48 21.87 109.10 C 19.42 107.82 18.47 104.80 19.75 102.35 C 32.12 78.59 54.29 62.03 80.56 56.92 C 108.15 51.56 136.83 59.91 157.28 79.25 C 159.29 81.14 159.38 84.31 157.48 86.31 C 155.58 88.32 152.42 88.41 150.41 86.51 C 132.30 69.38 106.90 61.99 82.47 66.74 C 59.21 71.26 39.58 85.92 28.61 106.97 C 27.72 108.68 25.98 109.66 24.18 109.66 Z"
              fill="#afeb75" fill-rule="nonzero" group-id="3" node-id="419" stroke="none" target-height="58.098003"
              target-width="140.907" target-x="18.47" target-y="51.564" />
            <path
              d="M 167.67 122.96 C 165.60 122.96 163.67 121.67 162.95 119.61 C 151.64 87.19 117.65 67.69 83.88 74.25 C 66.20 77.69 50.74 87.67 40.33 102.36 C 38.73 104.61 35.61 105.14 33.36 103.54 C 31.10 101.95 30.57 98.83 32.17 96.57 C 44.07 79.78 61.76 68.36 81.97 64.44 C 100.89 60.76 120.48 64.05 137.13 73.71 C 153.62 83.27 166.14 98.40 172.39 116.31 C 173.30 118.92 171.92 121.77 169.32 122.68 C 168.77 122.87 168.21 122.96 167.67 122.96 Z"
              fill="#75d5eb" fill-rule="nonzero" group-id="3" node-id="421" stroke="none" target-height="62.201"
              target-width="142.728" target-x="30.571" target-y="60.758" />
            <path
              d="M 198.35 88.19 C 198.35 123.61 175.70 152.32 147.76 152.32 C 119.82 152.32 97.17 123.61 97.17 88.19 C 97.17 52.77 119.82 24.05 147.76 24.05 C 175.70 24.05 198.35 52.77 198.35 88.19 Z"
              fill="#e6e3f7" fill-rule="nonzero" node-id="424" stroke="none" target-height="128.274"
              target-width="101.18201" target-x="97.17" target-y="24.051" />
            <path
              d="M 102.11 107.80 C 66.25 23.46 110.37 0.56 125.72 10.74 C 138.36 19.11 131.49 30.90 131.49 30.90 C 131.49 30.90 126.92 37.85 122.74 33.67 C 118.56 29.50 127.50 22.88 122.39 17.78 C 116.12 11.51 80.33 29.16 103.20 94.24 L 102.11 107.80 Z"
              fill="#edb0b0" fill-rule="nonzero" group-id="4" node-id="427" stroke="none" target-height="107.238"
              target-width="72.111" target-x="66.247" target-y="0.564" />
            <path
              d="M 94.17 24.82 C 94.17 24.82 82.81 53.37 102.26 97.84 L 101.45 106.23 C 101.45 106.22 79.96 59.33 94.17 24.82 Z"
              fill="#d9a1a1" fill-rule="nonzero" group-id="4" node-id="429" stroke="none" target-height="81.402"
              target-width="22.294998" target-x="79.961" target-y="24.824" />
            <path
              d="M 95.77 51.57 L 95.77 51.57 C 97.46 21.40 117.81 13.19 122.39 17.77 C 127.50 22.88 118.56 29.50 122.74 33.67 C 126.92 37.85 131.50 30.90 131.50 30.90 C 131.50 30.90 132.13 29.80 132.66 28.04 L 132.66 28.04 C 132.66 28.04 130.77 31.68 127.14 28.04 C 123.51 24.41 132.82 14.62 118.07 12.93 C 102.25 11.11 93.44 41.73 95.77 51.57 Z"
              fill="#d9a1a1" fill-rule="nonzero" group-id="4" node-id="431" stroke="none" target-height="40.452003"
              target-width="39.381004" target-x="93.436" target-y="11.114" />
            <path
              d="M 125.73 131.43 C 133.00 134.52 139.82 137.01 146.19 138.99 C 213.78 159.90 232.10 121.85 222.80 107.82 C 214.43 95.18 202.64 102.04 202.64 102.04 C 202.64 102.04 195.69 106.62 199.87 110.80 C 204.04 114.97 210.66 106.04 215.76 111.14 C 222.03 117.41 204.38 153.20 139.30 130.33 L 125.73 131.43 Z"
              fill="#edb0b0" fill-rule="nonzero" group-id="4" node-id="433" stroke="none" target-height="64.717"
              target-width="106.364" target-x="125.733" target-y="95.18" />
            <path
              d="M 208.04 139.73 C 208.04 139.73 179.50 151.09 135.02 131.65 L 126.64 132.46 C 126.64 132.46 173.54 153.94 208.04 139.73 Z"
              fill="#d9a1a1" fill-rule="nonzero" group-id="4" node-id="435" stroke="none" target-height="22.293991"
              target-width="81.399" target-x="126.638" target-y="131.645" />
            <path
              d="M 181.30 138.13 L 181.30 138.13 C 211.47 136.45 219.67 116.09 215.09 111.51 C 209.99 106.40 203.37 115.34 199.19 111.16 C 195.01 106.99 201.97 102.41 201.97 102.41 C 201.97 102.41 203.07 101.77 204.82 101.24 L 204.82 101.24 C 204.82 101.24 201.19 103.13 204.82 106.77 C 208.46 110.40 218.24 101.08 219.93 115.83 C 221.75 131.65 191.13 140.47 181.30 138.13 Z"
              fill="#d9a1a1" fill-rule="nonzero" group-id="4" node-id="437" stroke="none" target-height="39.379997"
              target-width="40.453003" target-x="181.298" target-y="101.085" />
            <path
              d="M 100.73 108.39 C 91.40 86.44 78.22 45.86 94.85 20.73 C 100.54 12.12 109.03 6.98 117.57 6.98 C 120.97 6.98 124.08 7.85 126.55 9.48 C 140.21 18.53 132.87 31.52 132.79 31.65 C 132.43 32.21 129.49 36.51 125.64 36.51 C 124.19 36.51 122.86 35.91 121.68 34.73 C 119.00 32.06 120.31 28.67 121.35 25.95 C 122.58 22.77 123.23 20.73 121.33 18.84 C 120.85 18.36 119.98 18.09 118.89 18.09 C 115.18 18.09 109.38 21.02 104.75 27.55 C 98.91 35.79 91.13 55.35 104.62 93.74 L 104.73 94.04 L 103.61 107.92 L 100.73 108.39 Z M 117.57 9.98 C 110.04 9.98 102.48 14.62 97.35 22.38 C 90.81 32.26 82.94 55.45 101.12 101.44 L 101.69 94.44 C 87.89 54.97 96.14 34.51 102.30 25.82 C 107.91 17.90 114.74 15.09 118.89 15.09 C 120.81 15.09 122.39 15.65 123.45 16.72 C 126.82 20.09 125.34 23.94 124.15 27.03 C 123.00 30.01 122.63 31.44 123.80 32.61 C 124.40 33.22 125.00 33.51 125.64 33.51 C 127.53 33.51 129.65 30.96 130.24 30.07 C 130.44 29.71 136.16 19.45 124.89 11.99 C 122.91 10.68 120.38 9.98 117.57 9.98 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="4" node-id="439" stroke="none" target-height="101.406"
              target-width="61.988" target-x="78.221" target-y="6.982" />
            <path
              d="M 182.13 146.63 C 182.12 146.63 182.12 146.63 182.12 146.63 C 171.30 146.63 159.06 144.54 145.75 140.42 C 139.15 138.38 132.22 135.81 125.14 132.81 L 125.61 129.93 L 139.50 128.81 L 139.80 128.92 C 153.89 133.87 166.72 136.38 177.91 136.38 C 177.92 136.38 177.92 136.38 177.92 136.38 C 199.54 136.38 211.14 126.90 214.51 118.78 C 215.87 115.49 215.56 113.07 214.70 112.21 C 213.89 111.40 213.02 111.02 211.96 111.02 C 210.61 111.02 209.07 111.61 207.58 112.19 C 205.97 112.81 204.30 113.45 202.65 113.45 C 201.15 113.45 199.86 112.91 198.80 111.86 C 197.15 110.20 196.94 108.50 197.05 107.37 C 197.42 103.78 201.37 101.08 201.81 100.79 C 202.03 100.66 205.48 98.68 210.08 98.68 C 213.95 98.68 219.51 100.12 224.05 106.99 C 227.53 112.24 227.34 120.18 223.57 127.21 C 220.43 133.05 210.11 146.63 182.13 146.63 Z M 132.10 132.42 C 137.07 134.38 141.94 136.10 146.64 137.56 C 159.66 141.59 171.60 143.63 182.12 143.63 C 182.12 143.63 182.12 143.63 182.13 143.63 C 208.50 143.63 218.04 131.15 220.93 125.79 C 224.19 119.72 224.43 112.99 221.55 108.64 C 218.49 104.02 214.63 101.68 210.08 101.68 C 206.28 101.68 203.42 103.32 203.39 103.34 C 202.58 103.88 200.22 105.82 200.04 107.68 C 199.99 108.14 200.04 108.85 200.93 109.73 C 201.42 110.23 201.95 110.45 202.65 110.45 C 203.74 110.45 205.08 109.93 206.51 109.38 C 208.25 108.71 210.06 108.02 211.96 108.02 C 213.82 108.02 215.45 108.71 216.82 110.08 C 218.80 112.06 218.97 115.83 217.28 119.92 C 216.08 122.81 212.91 128.34 205.09 132.93 C 197.78 137.21 188.65 139.38 177.92 139.38 C 177.92 139.38 177.92 139.38 177.92 139.38 C 166.46 139.38 153.40 136.85 139.10 131.85 L 132.10 132.42 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="4" node-id="441" stroke="none" target-height="47.947006"
              target-width="102.38801" target-x="125.145" target-y="98.683" />
            <path
              d="M 63.47 146.40 C 65.57 146.00 68.52 146.92 70.03 148.43 L 85.23 163.63 C 86.75 165.14 87.66 168.09 87.26 170.19 L 86.77 172.77 C 86.38 174.87 85.08 177.57 83.88 178.76 C 82.68 179.95 80.47 179.69 78.96 178.18 L 55.48 154.70 C 53.97 153.19 53.71 150.98 54.91 149.78 C 56.10 148.59 58.79 147.29 60.89 146.89 L 63.47 146.40 Z"
              fill="#ccccde" fill-rule="nonzero" group-id="4,12" node-id="445" stroke="none" target-height="33.947006"
              target-width="33.947" target-x="53.711" target-y="146.004" />
            <path
              d="M 81.95 181.01 C 80.50 181.01 79.02 180.37 77.90 179.24 L 54.42 155.76 C 52.32 153.66 52.06 150.50 53.84 148.72 C 55.25 147.32 58.22 145.87 60.61 145.42 L 63.19 144.93 C 63.61 144.85 64.06 144.81 64.53 144.81 C 66.93 144.81 69.56 145.84 71.09 147.37 L 86.30 162.57 C 88.15 164.43 89.22 167.90 88.73 170.47 L 88.25 173.05 C 87.79 175.45 86.34 178.42 84.94 179.82 C 84.17 180.59 83.11 181.01 81.95 181.01 Z M 64.53 147.81 C 64.25 147.81 63.99 147.83 63.75 147.88 L 61.17 148.36 C 59.38 148.70 56.95 149.86 55.96 150.84 C 55.44 151.37 55.55 152.64 56.54 153.64 L 80.02 177.12 C 80.58 177.68 81.30 178.01 81.95 178.01 C 82.20 178.01 82.56 177.95 82.82 177.70 C 83.80 176.72 84.96 174.28 85.30 172.49 L 85.78 169.91 C 86.09 168.29 85.34 165.85 84.17 164.69 L 68.97 149.48 C 68.02 148.53 66.11 147.81 64.53 147.81 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="4,12" node-id="447" stroke="none" target-height="36.199997"
              target-width="37.159" target-x="52.063" target-y="144.81" />
            <path
              d="M 42.91 150.29 C 42.91 150.29 44.32 148.89 46.04 147.17 C 47.76 145.45 51.24 146.12 53.78 148.66 L 84.98 179.86 C 87.52 182.40 88.19 185.88 86.47 187.60 C 84.75 189.32 83.35 190.73 83.35 190.73"
              fill="#ccccde" fill-rule="nonzero" group-id="4" node-id="450" stroke="none" target-height="45.28"
              target-width="45.278004" target-x="42.912" target-y="145.448" />
            <path
              d="M 222.62 87.99 C 220.61 90.00 217.10 89.78 214.81 87.50 L 145.13 17.82 C 142.85 15.54 142.63 12.03 144.64 10.02 C 146.66 8.00 150.17 8.22 152.45 10.51 L 222.13 80.19 C 224.41 82.47 224.63 85.98 222.62 87.99 Z"
              fill="#edb0b0" fill-rule="nonzero" group-id="4,13" node-id="454" stroke="none" target-height="81.999"
              target-width="82.002" target-x="142.632" target-y="8.003" />
            <path
              d="M 86.34 164.74 C 92.02 159.05 98.05 143.15 104.48 136.72 C 113.03 128.17 119.03 130.53 119.03 130.53 C 176.30 140.38 214.89 87.57 214.89 87.57 L 144.70 17.39 C 144.70 17.39 96.18 56.81 102.67 114.18 C 102.67 114.18 105.11 123.87 96.48 128.73 C 88.56 133.19 74.15 141.18 68.47 146.86 L 86.34 164.74 Z"
              fill="#f7b8b8" fill-rule="nonzero" group-id="4" node-id="457" stroke="none" target-height="147.34698"
              target-width="146.419" target-x="68.471" target-y="17.389" />
            <path d="M 193.51 73.86 L 140.88 21.22 L 144.71 17.39 L 197.34 70.02 Z" fill="#d9a1a1" fill-rule="nonzero"
              group-id="4,14" node-id="461" stroke="none" target-height="56.466896" target-width="56.46689"
              target-x="140.87524" target-y="17.388123" />
            <path
              d="M 119.03 130.56 C 176.32 140.35 214.86 87.52 214.86 87.52 L 197.07 69.75 C 197.07 69.75 154.79 120.67 126.45 120.69 C 126.45 120.69 102.11 130.34 91.61 142.64 C 91.61 142.64 88.19 146.83 85.45 155.18 C 84.21 158.95 81.97 160.39 81.97 160.39 L 86.38 164.78 C 92.05 159.10 98.07 143.20 104.50 136.76 C 113.04 128.21 119.03 130.56 119.03 130.56 Z"
              fill="#d9a1a1" fill-rule="nonzero" group-id="4" node-id="464" stroke="none" target-height="95.034"
              target-width="132.889" target-x="81.975" target-y="69.75" />
            <path
              d="M 207.96 80.64 C 207.96 80.64 176.90 130.53 119.02 130.53 C 119.02 130.53 176.51 141.59 214.81 87.50 L 207.96 80.64 Z"
              fill="#cc9797" fill-rule="nonzero" group-id="4" node-id="466" stroke="none" target-height="60.955"
              target-width="95.793" target-x="119.022" target-y="80.64" />
            <path
              d="M 115.73 99.76 C 122.75 75.03 160.06 40.92 160.06 40.92 L 148.96 29.82 C 139.60 39.78 116.76 66.42 110.55 95.09 C 107.89 107.35 106.03 117.05 102.80 122.93 C 101.83 126.11 101.43 128.08 97.52 130.28 C 89.60 134.75 74.15 141.70 68.47 147.38 L 73.22 152.13 C 78.38 146.96 95.00 136.57 103.55 128.02 C 109.34 122.23 115.73 99.76 115.73 99.76 Z"
              fill="#ffffff" fill-opacity="0.5" fill-rule="nonzero" group-id="4,15" node-id="470" stroke="none"
              target-height="122.30401" target-width="91.588005" target-x="68.471" target-y="29.822" />
            <path
              d="M 204.72 70.15 C 202.71 72.16 199.20 71.94 196.92 69.66 L 151.17 23.91 C 148.89 21.64 148.67 18.12 150.68 16.11 C 152.70 14.10 156.21 14.32 158.49 16.60 L 204.24 62.34 C 206.51 64.62 206.74 68.14 204.72 70.15 Z"
              fill="#fcbbbb" fill-rule="nonzero" group-id="4,16" node-id="475" stroke="none" target-height="58.061005"
              target-width="58.063004" target-x="148.672" target-y="14.099" />
            <path
              d="M 72.18 153.17 L 65.23 160.11 L 59.19 154.06 C 59.19 154.06 64.65 148.42 67.43 148.42 L 72.18 153.17 Z"
              fill="#ffffff" fill-opacity="0.56" fill-rule="nonzero" group-id="4,17" node-id="480" stroke="none"
              target-height="11.694992" target-width="12.995998" target-x="59.185" target-y="148.417" />
            <path d="M 81.99 160.38 L 73.75 168.63 L 83.88 178.76 C 83.88 178.76 91.19 169.59 81.99 160.38 Z"
              fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="4,18" node-id="485" stroke="none"
              target-height="18.37999" target-width="17.446999" target-x="73.747" target-y="160.382" />
            <path d="M 58.99 166.37 L 48.09 155.47 L 53.79 149.77 L 64.68 160.67 Z" fill="#ffffff" fill-opacity="0.66"
              fill-rule="nonzero" group-id="4,19" node-id="490" stroke="none" target-height="16.590698"
              target-width="16.59069" target-x="48.091637" target-y="149.77438" />
            <path d="M 86.63 188.83 L 82.49 189.87 L 70.39 177.77 L 76.64 171.52 L 85.45 180.33 L 86.46 183.62 Z"
              fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="4,20" node-id="495" stroke="none"
              target-height="18.347" target-width="16.244003" target-x="70.389" target-y="171.519" />
            <path
              d="M 83.35 192.85 L 40.79 150.29 L 44.98 146.11 C 45.89 145.19 47.13 144.71 48.57 144.71 C 50.70 144.71 53.04 145.79 54.85 147.60 L 86.04 178.80 C 87.48 180.23 88.46 181.99 88.80 183.75 C 89.17 185.69 88.71 187.49 87.53 188.66 L 83.35 192.85 Z M 45.03 150.29 L 83.35 188.61 L 85.41 186.54 C 86.04 185.91 85.96 184.88 85.85 184.32 C 85.63 183.16 84.92 181.92 83.92 180.92 L 52.72 149.72 C 51.48 148.49 49.89 147.72 48.57 147.72 C 48.13 147.72 47.52 147.80 47.10 148.23 L 45.03 150.29 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="4" node-id="498" stroke="none" target-height="48.136"
              target-width="48.379997" target-x="40.792" target-y="144.713" />
            <path
              d="M 86.34 166.86 L 66.35 146.86 L 67.41 145.80 C 72.98 140.23 86.54 132.60 94.64 128.05 L 95.75 127.42 C 103.28 123.17 101.24 114.63 101.22 114.55 L 101.18 114.35 C 97.78 84.26 109.54 59.18 120.00 43.44 C 131.32 26.42 143.25 16.63 143.76 16.23 L 144.81 15.37 L 216.86 87.42 L 216.10 88.46 C 215.77 88.91 182.79 133.25 133.25 133.25 C 128.45 133.25 123.58 132.84 118.77 132.01 L 118.47 131.93 L 118.47 131.93 C 118.47 131.93 117.90 131.73 116.90 131.73 C 114.92 131.73 110.80 132.52 105.54 137.78 C 102.37 140.95 99.22 146.69 96.16 152.25 C 93.15 157.72 90.31 162.89 87.40 165.80 L 86.34 166.86 Z M 70.63 146.90 L 86.29 162.56 C 88.59 159.79 91.00 155.41 93.53 150.80 C 96.69 145.06 99.95 139.13 103.42 135.66 C 109.14 129.93 113.91 128.73 116.90 128.73 C 118.18 128.73 119.03 128.96 119.40 129.07 C 124.00 129.86 128.66 130.25 133.25 130.25 C 177.14 130.25 207.70 94.25 212.90 87.70 L 144.63 19.43 C 137.72 25.54 98.41 62.72 104.16 113.92 C 105.06 117.70 104.76 125.79 97.22 130.03 L 96.11 130.66 C 88.65 134.86 76.47 141.71 70.63 146.90 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="4" node-id="500" stroke="none" target-height="151.48601"
              target-width="150.509" target-x="66.349" target-y="15.372" />
            <path d="M 164.72 35.22 L 153.83 24.34 L 159.53 18.64 L 170.42 29.52 Z" fill="#ffffff" fill-opacity="0.62"
              fill-rule="nonzero" group-id="4,21" node-id="504" stroke="none" target-height="16.58857"
              target-width="16.588562" target-x="153.83235" target-y="18.63562" />
            <path d="M 175.10 45.59 L 169.92 40.40 L 176.14 34.18 L 181.32 39.37 Z" fill="#ffffff" fill-opacity="0.34"
              fill-rule="nonzero" group-id="4,22" node-id="509" stroke="none" target-height="11.402817"
              target-width="11.402557" target-x="169.91776" target-y="34.18309" />
            <path
              d="M 169.22 49.56 C 169.22 49.56 135.65 80.35 125.76 97.17 C 115.19 115.14 104.98 126.28 104.98 126.28 C 104.98 126.28 118.56 103.92 124.38 92.33 C 133.07 75.02 165.07 45.41 165.07 45.41 L 169.22 49.56 Z"
              fill="#d9a1a1" fill-opacity="0.44" fill-rule="nonzero" group-id="4,23" node-id="514" stroke="none"
              target-height="80.865" target-width="64.23599" target-x="104.981" target-y="45.414" />
            <path
              d="M 87.50 196.38 C 87.11 196.38 86.73 196.23 86.44 195.94 L 38.73 148.23 C 38.14 147.64 38.14 146.69 38.73 146.11 C 39.31 145.52 40.26 145.52 40.85 146.11 L 88.56 193.82 C 89.14 194.40 89.14 195.35 88.56 195.94 C 88.26 196.23 87.88 196.38 87.50 196.38 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="4" node-id="517" stroke="none" target-height="50.85501"
              target-width="51.002" target-x="38.14" target-y="145.521" />
            <path
              d="M 188.23 68.57 C 188.23 68.57 155.48 113.81 124.03 120.70 C 124.03 120.70 153.78 122.08 193.51 73.86 L 188.23 68.57 Z"
              fill="#f7c6c6" fill-rule="nonzero" group-id="4" node-id="519" stroke="none" target-height="53.508003"
              target-width="69.485" target-x="124.028" target-y="68.573" />
            <path d="M 197.06 69.76 L 191.88 64.57 L 198.93 57.52 L 204.12 62.70 Z" fill="#f7c6c6" fill-rule="nonzero"
              group-id="4,24" node-id="523" stroke="none" target-height="12.238922" target-width="12.239456"
              target-x="191.87654" target-y="57.51912" />
            <path d="M 146.84 105.32 L 146.84 126.40 L 154.48 118.76 L 161.75 126.03 L 161.75 105.01 Z" fill="#d9a1a1"
              fill-rule="nonzero" group-id="4" node-id="526" stroke="none" target-height="21.387001"
              target-width="14.909012" target-x="146.844" target-y="105.011" />
            <path
              d="M 175.11 85.83 C 175.11 97.44 165.70 106.85 154.09 106.85 C 142.48 106.85 133.07 97.44 133.07 85.83 C 133.07 74.22 142.48 64.80 154.09 64.80 C 165.70 64.80 175.11 74.22 175.11 85.83 Z"
              fill="#d9a1a1" fill-rule="nonzero" group-id="4" node-id="528" stroke="none" target-height="42.044"
              target-width="42.044006" target-x="133.069" target-y="64.804" />
            <path d="M 147.41 95.03 L 147.48 119.44 L 154.79 112.06 L 162.17 119.36 L 162.10 94.96" fill="#ff9999"
              fill-rule="nonzero" group-id="4,25,40" node-id="534" stroke="none" target-height="24.482002"
              target-width="14.7630005" target-x="147.408" target-y="94.958" />
            <path
              d="M 147.48 120.94 C 147.29 120.94 147.09 120.90 146.91 120.83 C 146.35 120.60 145.98 120.05 145.98 119.44 L 145.91 95.04 C 145.91 94.21 146.58 93.53 147.41 93.53 C 147.41 93.53 147.41 93.53 147.41 93.53 C 148.24 93.53 148.91 94.20 148.91 95.03 L 148.97 115.80 L 153.72 111.00 C 154.31 110.41 155.25 110.41 155.84 110.99 L 160.66 115.76 L 160.60 94.96 C 160.60 94.14 161.27 93.46 162.09 93.46 C 162.10 93.46 162.10 93.46 162.10 93.46 C 162.93 93.46 163.60 94.13 163.60 94.95 L 163.67 119.36 C 163.67 119.97 163.31 120.52 162.75 120.75 C 162.19 120.98 161.55 120.86 161.12 120.43 L 154.80 114.18 L 148.55 120.50 C 148.26 120.79 147.87 120.94 147.48 120.94 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="4,25,40" node-id="536" stroke="none" target-height="27.526001"
              target-width="17.766998" target-x="145.907" target-y="93.459" />
            <path
              d="M 174.61 80.38 C 174.61 91.50 165.59 100.52 154.47 100.52 C 143.34 100.52 134.32 91.50 134.32 80.38 C 134.32 69.25 143.34 60.23 154.47 60.23 C 165.59 60.23 174.61 69.25 174.61 80.38 Z"
              fill="#ffd28f" fill-rule="nonzero" group-id="4,25" node-id="539" stroke="none" target-height="40.290005"
              target-width="40.291992" target-x="134.319" target-y="60.231" />
            <path
              d="M 137.60 81.42 C 137.60 71.59 145.57 63.62 155.40 63.62 C 159.71 63.62 164.60 65.15 167.67 67.69 C 164.41 63.74 158.53 61.22 153.00 61.22 C 143.17 61.22 135.20 69.19 135.20 79.03 C 135.20 84.55 137.72 90.12 141.67 93.38 C 139.13 90.30 137.60 85.73 137.60 81.42 Z"
              fill="#ffffff" fill-opacity="0.75" fill-rule="nonzero" group-id="4,25,41" node-id="543" stroke="none"
              target-height="32.156998" target-width="32.472992" target-x="135.201" target-y="61.222" />
            <path
              d="M 158.39 60.62 C 166.12 62.80 171.79 69.91 171.79 78.34 C 171.79 88.52 163.54 96.76 153.37 96.77 C 143.19 96.77 134.94 88.52 134.94 78.34 C 134.94 76.43 135.23 74.58 135.78 72.85 C 134.84 75.18 134.31 77.71 134.31 80.37 C 134.31 91.50 143.34 100.52 154.46 100.52 C 165.59 100.52 174.61 91.50 174.61 80.37 C 174.61 70.59 167.64 62.44 158.39 60.62 Z"
              fill="#e8b76d" fill-opacity="0.76" fill-rule="nonzero" group-id="4,25,42" node-id="548" stroke="none"
              target-height="39.904995" target-width="40.295" target-x="134.315" target-y="60.615" />
            <path
              d="M 148.79 82.56 C 148.79 79.00 151.76 76.11 155.43 76.11 C 156.85 76.11 158.17 76.55 159.25 77.29 C 158.13 75.27 155.93 73.90 153.40 73.90 C 149.74 73.90 146.77 76.79 146.77 80.35 C 146.77 82.53 147.88 84.45 149.58 85.62 C 149.08 84.71 148.79 83.67 148.79 82.56 Z"
              fill="#8b5c29" fill-opacity="0.15" fill-rule="nonzero" group-id="4,25,43" node-id="553" stroke="none"
              target-height="11.720001" target-width="12.479996" target-x="146.768" target-y="73.9" />
            <path
              d="M 153.67 87.23 C 150.01 87.23 147.04 84.26 147.04 80.61 C 147.04 78.84 147.73 77.17 148.98 75.92 C 150.23 74.67 151.89 73.99 153.67 73.99 C 155.43 73.99 157.10 74.67 158.35 75.92 C 159.60 77.17 160.29 78.84 160.29 80.61 L 160.29 80.61 C 160.29 81.47 160.98 82.17 161.85 82.17 C 162.72 82.17 163.41 81.47 163.41 80.61 L 163.41 80.61 C 163.41 78.00 162.40 75.55 160.56 73.71 C 158.72 71.87 156.27 70.86 153.66 70.86 C 151.06 70.86 148.60 71.87 146.77 73.71 C 144.93 75.56 143.91 78.00 143.91 80.61 C 143.91 85.99 148.29 90.36 153.67 90.36 L 153.67 90.36 C 154.53 90.36 155.23 89.66 155.23 88.80 C 155.23 87.93 154.53 87.23 153.67 87.23 L 153.67 87.23 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="4,25,44" node-id="558" stroke="none" target-height="19.504997"
              target-width="19.501999" target-x="143.913" target-y="70.857" />
            <path
              d="M 158.34 93.56 C 157.66 93.56 157.05 93.09 156.88 92.41 C 156.69 91.60 157.19 90.79 157.99 90.60 C 162.36 89.54 164.37 84.59 164.39 84.54 C 164.70 83.77 165.57 83.40 166.34 83.71 C 167.11 84.01 167.49 84.89 167.18 85.66 C 167.08 85.92 164.55 92.09 158.70 93.52 C 158.58 93.54 158.46 93.56 158.34 93.56 Z"
              fill="#ffffff" fill-opacity="0.73" fill-rule="nonzero" group-id="4,25,45" node-id="563" stroke="none"
              target-height="10.154999" target-width="10.796997" target-x="156.69" target-y="83.401" />
            <path
              d="M 146.85 101.83 C 147.15 101.97 154.12 105.46 162.62 101.86 L 161.63 99.51 C 154.22 102.65 148.08 99.58 148.02 99.55 L 146.85 101.83 Z"
              fill="#6e6e96" fill-opacity="0.2" fill-rule="nonzero" group-id="4,25,46" node-id="568" stroke="none"
              target-height="5.9529953" target-width="15.770996" target-x="146.853" target-y="99.511" />
            <path
              d="M 154.47 102.02 C 142.53 102.02 132.82 92.31 132.82 80.37 C 132.82 68.44 142.53 58.73 154.47 58.73 C 166.40 58.73 176.11 68.44 176.11 80.38 C 176.11 92.31 166.40 102.02 154.47 102.02 Z M 154.47 61.73 C 144.18 61.73 135.82 70.09 135.82 80.38 C 135.82 90.66 144.18 99.02 154.47 99.02 C 164.75 99.02 173.11 90.66 173.11 80.38 C 173.11 70.09 164.75 61.73 154.47 61.73 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="4,25" node-id="571" stroke="none" target-height="43.289997"
              target-width="43.291992" target-x="132.819" target-y="58.73" />
            <path
              d="M 151.67 32.54 C 151.67 32.54 116.80 68.77 111.15 92.54 C 111.15 92.54 115.79 66.19 148.96 29.82 L 151.67 32.54 Z"
              fill="#ffffff" fill-rule="nonzero" group-id="4" node-id="574" stroke="none" target-height="62.717003"
              target-width="40.523994" target-x="111.15" target-y="29.824" />
            <path d="M 156.09 26.59 L 153.83 24.34 L 159.54 18.64 L 161.79 20.89 Z" fill="#ffffff" fill-rule="nonzero"
              group-id="4,26" node-id="578" stroke="none" target-height="7.952034" target-width="7.9520416"
              target-x="153.83487" target-y="18.6371" />
            <path
              d="M 219.17 90.87 C 217.19 90.87 215.22 90.03 213.75 88.56 L 144.07 18.88 C 141.20 16.01 140.98 11.56 143.58 8.96 C 144.76 7.79 146.36 7.14 148.10 7.14 C 150.07 7.14 152.05 7.98 153.51 9.44 L 223.19 79.13 C 224.55 80.49 225.37 82.25 225.48 84.09 C 225.60 86.01 224.96 87.77 223.68 89.05 C 222.51 90.22 220.91 90.87 219.17 90.87 Z M 148.10 10.14 C 147.16 10.14 146.31 10.47 145.71 11.08 C 144.27 12.51 144.49 15.06 146.20 16.76 L 215.88 86.44 C 216.78 87.35 217.98 87.87 219.17 87.87 C 220.11 87.87 220.96 87.53 221.56 86.93 C 222.22 86.27 222.56 85.33 222.49 84.28 C 222.42 83.17 221.92 82.09 221.07 81.25 L 151.39 11.57 C 150.49 10.66 149.28 10.14 148.10 10.14 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="4,27" node-id="583" stroke="none" target-height="83.726"
              target-width="84.621" target-x="140.983" target-y="7.14" />
            <path
              d="M 98.04 150.76 C 95.73 153.24 91.81 153.38 89.34 151.07 L 73.64 136.47 C 71.17 134.16 71.02 130.24 73.33 127.77 L 73.67 127.41 C 75.97 124.93 79.89 124.79 82.36 127.09 L 98.06 141.70 C 100.54 144.01 100.68 147.92 98.37 150.40 L 98.04 150.76 Z"
              fill="#ffeae0" fill-rule="nonzero" group-id="5" node-id="589" stroke="none" target-height="28.587997"
              target-width="29.652" target-x="71.024" target-y="124.789" />
            <path
              d="M 93.53 154.21 C 91.58 154.21 89.73 153.49 88.31 152.17 L 72.62 137.56 C 71.13 136.17 70.27 134.28 70.19 132.23 C 70.12 130.18 70.84 128.24 72.23 126.74 L 72.57 126.39 C 74.01 124.84 76.05 123.95 78.17 123.95 C 80.12 123.95 81.97 124.68 83.39 126.00 L 99.08 140.60 C 102.17 143.48 102.34 148.33 99.47 151.42 L 99.14 151.78 C 97.70 153.33 95.65 154.21 93.53 154.21 Z M 78.18 126.95 C 76.88 126.95 75.64 127.49 74.76 128.43 L 74.43 128.79 C 73.59 129.69 73.15 130.88 73.19 132.12 C 73.24 133.37 73.76 134.52 74.67 135.37 L 90.36 149.97 C 91.22 150.77 92.34 151.21 93.53 151.21 C 94.82 151.21 96.07 150.67 96.94 149.73 L 97.27 149.38 C 99.02 147.50 98.92 144.55 97.03 142.80 L 81.34 128.19 C 80.48 127.39 79.36 126.95 78.18 126.95 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="5" node-id="591" stroke="none" target-height="30.259995"
              target-width="32.222" target-x="70.121" target-y="123.953" />
            <path
              d="M 91.68 144.45 C 89.66 146.63 85.97 146.51 83.49 144.21 L 78.98 140.01 C 76.50 137.70 76.12 134.04 78.15 131.86 C 80.17 129.69 83.85 129.80 86.33 132.11 L 90.85 136.31 C 93.33 138.61 93.70 142.28 91.68 144.45 Z"
              fill="#ffdfd1" fill-rule="nonzero" group-id="5" node-id="593" stroke="none" target-height="16.936005"
              target-width="17.574997" target-x="76.125" target-y="129.69" />
            <path
              d="M 106.76 141.38 C 104.45 143.86 100.54 144.00 98.06 141.70 L 80.98 125.81 C 78.51 123.50 78.37 119.58 80.67 117.11 L 81.01 116.75 C 83.31 114.27 87.23 114.13 89.71 116.44 L 106.78 132.33 C 109.26 134.63 109.40 138.55 107.09 141.03 L 106.76 141.38 Z"
              fill="#ffeae0" fill-rule="nonzero" group-id="5" node-id="595" stroke="none" target-height="29.875008"
              target-width="31.029999" target-x="78.369" target-y="114.128" />
            <path
              d="M 99.26 133.91 C 97.23 136.09 93.55 135.98 91.07 133.67 L 86.55 129.47 C 84.08 127.16 83.70 123.50 85.73 121.32 C 87.75 119.15 91.43 119.26 93.91 121.57 L 98.43 125.77 C 100.91 128.07 101.28 131.74 99.26 133.91 Z"
              fill="#ffdfd1" fill-rule="nonzero" group-id="5" node-id="597" stroke="none" target-height="16.935997"
              target-width="17.575996" target-x="83.703" target-y="119.152" />
            <path
              d="M 102.25 144.84 C 100.31 144.84 98.45 144.11 97.04 142.80 L 79.96 126.90 C 76.88 124.03 76.70 119.17 79.58 116.08 L 79.91 115.72 C 81.35 114.18 83.39 113.29 85.52 113.29 C 87.46 113.29 89.31 114.02 90.73 115.34 L 107.80 131.23 C 110.89 134.10 111.07 138.96 108.19 142.05 L 107.86 142.41 C 106.42 143.95 104.38 144.84 102.25 144.84 Z M 85.52 116.29 C 84.22 116.29 82.98 116.83 82.11 117.77 L 81.77 118.13 C 80.02 120.01 80.13 122.96 82.01 124.71 L 99.08 140.60 C 99.94 141.40 101.07 141.84 102.25 141.84 C 103.55 141.84 104.79 141.30 105.66 140.36 L 106.00 140.00 C 107.75 138.12 107.64 135.17 105.76 133.42 L 88.69 117.53 C 87.83 116.73 86.70 116.29 85.52 116.29 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="5" node-id="599" stroke="none" target-height="31.547005"
              target-width="34.365005" target-x="76.701" target-y="113.292" />
            <path
              d="M 115.48 132.02 C 113.17 134.49 109.26 134.63 106.78 132.33 L 92.27 118.82 C 89.79 116.51 89.65 112.60 91.96 110.12 L 92.29 109.76 C 94.60 107.28 98.51 107.14 100.99 109.45 L 115.50 122.96 C 117.98 125.27 118.12 129.18 115.82 131.66 L 115.48 132.02 Z"
              fill="#ffeae0" fill-rule="nonzero" group-id="5" node-id="601" stroke="none" target-height="27.490997"
              target-width="28.473999" target-x="89.65" target-y="107.142" />
            <path
              d="M 110.00 126.34 C 107.97 128.52 104.29 128.41 101.81 126.10 L 97.30 121.90 C 94.82 119.59 94.44 115.92 96.47 113.75 C 98.49 111.58 102.17 111.69 104.65 114.00 L 109.17 118.20 C 111.65 120.50 112.02 124.17 110.00 126.34 Z"
              fill="#ffdfd1" fill-rule="nonzero" group-id="5" node-id="603" stroke="none" target-height="16.938004"
              target-width="17.576996" target-x="94.442" target-y="111.58" />
            <path
              d="M 110.97 135.47 C 109.03 135.47 107.18 134.74 105.76 133.43 L 91.24 119.92 C 88.16 117.04 87.98 112.19 90.86 109.10 L 91.19 108.74 C 92.63 107.19 94.67 106.31 96.80 106.31 C 98.74 106.31 100.59 107.03 102.01 108.35 L 116.53 121.86 C 119.61 124.74 119.79 129.59 116.91 132.68 L 116.58 133.04 C 115.14 134.58 113.10 135.47 110.97 135.47 Z M 96.80 109.31 C 95.51 109.31 94.26 109.84 93.39 110.78 L 93.05 111.14 C 91.31 113.02 91.41 115.97 93.29 117.72 L 107.81 131.23 C 108.66 132.03 109.79 132.47 110.97 132.47 C 112.27 132.47 113.51 131.93 114.38 130.99 L 114.72 130.63 C 115.56 129.73 116.00 128.54 115.96 127.30 C 115.91 126.05 115.39 124.90 114.48 124.05 L 99.97 110.54 C 99.11 109.75 97.98 109.31 96.80 109.31 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="5" node-id="605" stroke="none" target-height="29.162994"
              target-width="31.807999" target-x="87.982" target-y="106.306" />
            <path
              d="M 88.96 158.09 C 86.94 160.27 83.25 160.16 80.78 157.85 L 70.71 148.48 C 68.23 146.17 67.86 142.51 69.88 140.34 C 71.90 138.16 75.59 138.27 78.07 140.58 L 88.13 149.95 C 90.61 152.26 90.98 155.92 88.96 158.09 Z"
              fill="#ffeae0" fill-rule="nonzero" group-id="5" node-id="607" stroke="none" target-height="22.104996"
              target-width="23.127998" target-x="67.857" target-y="138.162" />
            <path
              d="M 84.11 154.53 C 82.09 156.70 78.40 156.59 75.92 154.28 L 74.33 152.80 C 71.85 150.49 71.47 146.83 73.50 144.65 C 75.52 142.48 79.21 142.59 81.69 144.90 L 83.28 146.38 C 85.76 148.69 86.13 152.35 84.11 154.53 Z"
              fill="#ffdfd1" fill-rule="nonzero" group-id="5" node-id="609" stroke="none" target-height="14.221008"
              target-width="14.653999" target-x="71.475" target-y="142.478" />
            <path
              d="M 85.21 161.16 C 83.22 161.16 81.28 160.37 79.75 158.95 L 69.69 149.58 C 68.22 148.22 67.31 146.41 67.12 144.51 C 66.92 142.53 67.51 140.69 68.79 139.31 C 70.01 138.00 71.73 137.28 73.63 137.28 C 75.62 137.28 77.56 138.06 79.09 139.48 L 89.15 148.85 C 92.24 151.73 92.65 156.33 90.06 159.12 C 88.83 160.43 87.11 161.16 85.21 161.16 Z M 73.63 140.27 C 72.57 140.27 71.63 140.66 70.98 141.36 C 70.30 142.09 69.99 143.10 70.10 144.21 C 70.22 145.39 70.80 146.52 71.73 147.38 L 81.80 156.75 C 82.75 157.65 84.00 158.16 85.21 158.16 C 86.27 158.16 87.21 157.77 87.86 157.07 C 89.33 155.50 88.99 152.80 87.11 151.05 L 77.04 141.68 C 76.09 140.79 74.84 140.27 73.63 140.27 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="5" node-id="611" stroke="none" target-height="23.881012"
              target-width="25.735" target-x="66.915" target-y="137.275" />
            <path
              d="M 77.70 148.78 C 77.33 148.78 76.96 148.65 76.67 148.38 C 76.07 147.81 76.03 146.87 76.60 146.26 L 80.11 142.48 C 80.68 141.88 81.63 141.84 82.23 142.41 C 82.84 142.97 82.87 143.92 82.31 144.53 L 78.80 148.30 C 78.50 148.62 78.10 148.78 77.70 148.78 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="5" node-id="613" stroke="none" target-height="6.9380035"
              target-width="6.840004" target-x="76.034" target-y="141.842" />
            <path
              d="M 83.16 137.28 C 82.80 137.28 82.43 137.15 82.14 136.88 C 81.53 136.31 81.50 135.37 82.06 134.76 L 86.03 130.50 C 86.59 129.89 87.54 129.86 88.15 130.42 C 88.75 130.99 88.79 131.94 88.22 132.54 L 84.26 136.80 C 83.96 137.12 83.56 137.28 83.16 137.28 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="5" node-id="615" stroke="none" target-height="7.423004"
              target-width="7.290001" target-x="81.499" target-y="129.857" />
            <path
              d="M 91.38 124.79 C 91.02 124.79 90.65 124.66 90.36 124.39 C 89.75 123.82 89.72 122.87 90.28 122.27 L 92.17 120.25 C 92.73 119.64 93.68 119.61 94.29 120.17 C 94.89 120.74 94.93 121.69 94.36 122.29 L 92.48 124.31 C 92.18 124.63 91.78 124.79 91.38 124.79 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="5" node-id="617" stroke="none" target-height="5.183998"
              target-width="5.2070007" target-x="89.719" target-y="119.606" />
            <path
              d="M 102.62 118.39 C 102.25 118.39 101.88 118.25 101.59 117.98 C 100.99 117.42 100.95 116.47 101.52 115.86 L 104.47 112.69 C 105.04 112.08 105.99 112.05 106.59 112.61 C 107.20 113.18 107.23 114.13 106.67 114.73 L 103.72 117.91 C 103.42 118.22 103.02 118.39 102.62 118.39 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="5" node-id="619" stroke="none" target-height="6.338005"
              target-width="6.279999" target-x="100.954" target-y="112.047" />
            <path
              d="M 143.62 140.38 C 138.01 113.03 117.14 115.14 117.14 115.14 C 117.14 115.14 94.55 138.04 92.77 146.08 C 92.67 146.56 92.60 147.01 92.58 147.43 C 92.70 147.68 92.80 147.96 92.86 148.30 C 93.04 149.29 93.31 150.10 93.66 150.77 C 93.89 151.01 95.42 149.86 95.70 150.04 L 94.13 151.54 C 97.97 151.41 104.28 148.69 104.28 148.69 C 96.13 152.88 91.59 159.23 87.11 166.83 C 92.68 177.58 106.81 180.53 106.81 180.53 C 151.37 176.53 143.62 140.38 143.62 140.38 Z"
              fill="#ffdfd1" fill-rule="nonzero" node-id="622" stroke="none" target-height="67.501"
              target-width="64.25001" target-x="87.115" target-y="113.033" />
            <path
              d="M 106.73 181.32 C 91.86 181.32 86.67 169.88 85.71 167.36 C 85.42 166.59 85.81 165.72 86.58 165.43 C 87.35 165.13 88.22 165.52 88.52 166.29 C 89.44 168.70 94.87 180.60 111.49 177.93 C 112.31 177.78 113.08 178.35 113.21 179.17 C 113.35 179.98 112.79 180.75 111.97 180.89 C 110.11 181.19 108.36 181.32 106.73 181.32 Z"
              fill="#6e6e96" fill-rule="nonzero" node-id="624" stroke="none" target-height="16.19899"
              target-width="27.928001" target-x="85.418" target-y="165.126" />
            <path
              d="M 94.26 142.56 C 94.26 142.56 97.56 139.97 104.54 134.94 C 111.52 129.91 125.29 113.97 126.02 134.43 C 126.13 137.52 119.27 142.60 121.90 143.17 C 130.16 144.95 128.06 158.66 120.42 158.94 C 110.53 159.29 117.62 166.54 126.58 178.51 C 135.54 190.47 148.76 206.19 148.76 206.19 L 157.61 196.54 L 128.45 164.11 C 128.45 164.11 126.91 159.05 132.36 158.85 C 137.81 158.66 150.48 121.78 119.70 115.16 C 119.70 115.16 89.73 138.34 94.26 142.56 Z"
              fill="#ffffff" fill-opacity="0.42" fill-rule="nonzero" group-id="6" node-id="628" stroke="none"
              target-height="92.21" target-width="67.87899" target-x="89.732" target-y="113.975" />
            <path
              d="M 136.92 165.12 C 136.56 165.12 136.19 164.99 135.90 164.72 C 135.29 164.16 135.26 163.21 135.82 162.60 C 148.16 149.35 140.42 129.21 132.81 122.13 C 128.22 117.85 123.91 115.70 120.34 115.89 C 117.45 116.05 116.00 117.68 115.94 117.75 L 94.55 140.74 C 93.54 141.82 92.98 143.19 92.97 144.61 C 92.96 145.97 93.47 147.20 94.40 148.07 C 94.97 148.59 97.64 149.16 102.30 147.57 C 107.42 145.82 112.76 142.15 117.34 137.22 C 117.91 136.62 118.85 136.58 119.46 137.15 C 120.07 137.71 120.10 138.66 119.54 139.27 C 113.24 146.04 107.22 149.06 103.27 150.41 C 98.42 152.07 94.23 152.01 92.36 150.26 C 90.80 148.81 89.95 146.80 89.97 144.58 C 89.99 142.42 90.83 140.33 92.35 138.70 L 113.70 115.76 C 113.73 115.72 115.88 113.17 120.06 112.90 C 124.56 112.61 129.53 114.97 134.86 119.93 C 139.56 124.31 143.46 132.03 144.79 139.61 C 145.99 146.43 145.79 156.30 138.02 164.65 C 137.72 164.96 137.32 165.12 136.92 165.12 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="7" node-id="633" stroke="none" target-height="52.512"
              target-width="58.203995" target-x="89.955" target-y="112.611" />
            <path
              d="M 120.48 152.83 C 120.34 152.83 120.21 152.81 120.07 152.78 C 113.19 150.84 112.50 145.25 113.10 142.55 C 113.28 141.74 114.08 141.24 114.89 141.41 C 115.69 141.59 116.20 142.39 116.03 143.19 C 115.92 143.71 115.16 148.28 120.88 149.88 C 121.68 150.11 122.14 150.94 121.92 151.74 C 121.73 152.40 121.13 152.83 120.48 152.83 Z"
              fill="#6e6e96" fill-rule="nonzero" node-id="636" stroke="none" target-height="11.589996"
              target-width="9.644997" target-x="112.5" target-y="141.241" />
            <path
              d="M 101.62 156.84 L 95.00 163.94 C 95.00 163.94 90.59 169.22 100.21 166.32 C 107.24 166.07 133.37 196.84 144.60 210.15 C 146.33 212.20 146.33 212.20 146.33 212.20 L 135.90 217.90 L 110.17 179.46 C 110.17 179.46 87.54 178.93 87.04 164.94 L 99.67 149.83 L 111.39 144.47 L 120.58 134.88 C 120.58 134.88 113.41 142.22 120.43 145.12 C 132.38 150.07 120.81 159.31 115.59 154.46 C 108.95 148.27 108.24 149.73 101.62 156.84 Z"
              fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="8" node-id="640" stroke="none"
              target-height="83.022" target-width="59.290993" target-x="87.042" target-y="134.881" />
            <path
              d="M 92.12 141.72 C 92.12 141.72 95.06 149.10 104.05 143.15 C 109.50 139.55 117.03 132.71 122.12 133.67 C 124.38 134.10 122.24 137.17 119.07 140.57 C 105.98 154.64 87.32 151.51 92.12 141.72 Z"
              fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="9" node-id="645" stroke="none"
              target-height="21.925995" target-width="37.060997" target-x="87.317" target-y="132.714" />
            <path
              d="M 149.54 247.55 L 127.66 223.01 C 122.14 216.82 122.69 207.23 128.88 201.71 L 157.48 176.21 C 163.67 170.69 173.25 171.24 178.78 177.44 L 200.66 201.98"
              fill="#bad6ff" fill-rule="nonzero" group-id="10,28" node-id="652" stroke="none" target-height="76.85901"
              target-width="78.522995" target-x="122.14" target-y="170.693" />
            <path
              d="M 155.66 242.41 L 133.78 217.87 C 129.15 212.69 128.80 205.12 132.45 199.56 L 128.89 202.74 C 122.69 208.26 122.14 217.84 127.67 224.04 L 149.55 248.58 L 200.66 203.00 L 200.31 202.61 L 155.66 242.41 Z"
              fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="10,29" node-id="657" stroke="none"
              target-height="49.022995" target-width="78.518" target-x="122.145" target-y="199.558" />
            <path
              d="M 149.76 182.60 C 155.95 177.08 165.54 177.63 171.06 183.82 L 192.59 207.97 L 199.06 202.20 L 177.18 177.66 C 171.65 171.47 162.07 170.92 155.88 176.44 L 127.28 201.94 C 126.28 202.83 125.44 203.84 124.73 204.92 L 149.76 182.60 Z"
              fill="#ffffff" fill-opacity="0.28" fill-rule="nonzero" group-id="10,30" node-id="662" stroke="none"
              target-height="37.048004" target-width="74.329" target-x="124.729" target-y="170.922" />
            <path
              d="M 149.54 249.05 C 149.13 249.05 148.72 248.88 148.42 248.55 L 126.54 224.01 C 123.61 220.71 122.13 216.46 122.38 212.02 C 122.64 207.59 124.59 203.53 127.89 200.59 L 156.48 175.09 C 159.77 172.16 164.02 170.67 168.46 170.93 C 172.90 171.19 176.96 173.14 179.90 176.44 L 201.78 200.98 C 202.34 201.60 202.28 202.54 201.66 203.09 C 201.04 203.65 200.09 203.59 199.54 202.97 L 177.66 178.44 C 175.25 175.74 171.93 174.14 168.29 173.93 C 164.65 173.73 161.17 174.93 158.48 177.33 L 129.88 202.83 C 127.19 205.23 125.59 208.56 125.38 212.19 C 125.17 215.83 126.38 219.31 128.78 222.01 L 150.66 246.55 C 151.22 247.17 151.16 248.12 150.54 248.67 C 150.25 248.93 149.90 249.05 149.54 249.05 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="10,31" node-id="667" stroke="none" target-height="78.382"
              target-width="80.20701" target-x="122.128" target-y="170.67" />
            <path
              d="M 188.52 192.50 C 191.58 189.78 196.31 190.05 199.04 193.11 L 200.44 194.68 C 203.17 197.74 202.90 202.47 199.84 205.20 L 154.52 245.61 C 151.46 248.34 146.72 248.06 144.00 245.00 L 142.60 243.44 C 139.87 240.37 140.14 235.64 143.20 232.91 L 188.52 192.50 Z"
              fill="#bad6ff" fill-rule="nonzero" group-id="10" node-id="670" stroke="none" target-height="58.559998"
              target-width="63.300003" target-x="139.869" target-y="189.776" />
            <path
              d="M 149.57 249.00 C 147.10 249.00 144.64 247.99 142.88 246.00 L 141.48 244.44 C 138.19 240.75 138.52 235.07 142.20 231.79 L 164.65 211.77 C 165.27 211.22 166.22 211.28 166.77 211.89 C 167.32 212.51 167.27 213.46 166.65 214.01 L 144.20 234.03 C 141.75 236.22 141.53 239.99 143.72 242.44 L 145.12 244.01 C 147.30 246.46 151.07 246.68 153.53 244.49 L 198.84 204.08 C 200.02 203.03 200.72 201.57 200.81 199.98 C 200.90 198.39 200.37 196.86 199.32 195.68 L 197.92 194.11 C 195.73 191.66 191.96 191.44 189.51 193.62 L 176.41 205.31 C 175.79 205.87 174.84 205.81 174.29 205.19 C 173.74 204.57 173.79 203.62 174.41 203.07 L 187.52 191.39 C 191.21 188.10 196.88 188.43 200.16 192.12 L 201.56 193.68 C 203.15 195.46 203.94 197.76 203.81 200.15 C 203.67 202.55 202.62 204.74 200.84 206.32 L 155.52 246.73 C 153.82 248.25 151.69 249.00 149.57 249.00 Z"
              fill="#6e6e96" fill-rule="nonzero" group-id="10" node-id="672" stroke="none" target-height="60.893997"
              target-width="65.753006" target-x="138.192" target-y="188.102" />
            <path
              d="M 170.10 209.77 C 167.19 206.88 160.92 215.27 154.13 222.12 C 151.86 224.41 150.28 226.44 149.26 228.13 L 143.16 233.57 C 140.10 236.30 139.83 241.03 142.56 244.09 L 143.96 245.67 C 146.69 248.73 151.42 249.00 154.48 246.27 L 162.83 238.83 C 159.77 241.56 155.03 241.29 152.31 238.22 L 150.90 236.65 C 150.09 235.74 149.54 234.66 149.26 233.54 L 166.73 218.31 C 166.73 218.31 173.02 212.66 170.10 209.77 Z"
              fill="#6e6e96" fill-opacity="0.15" fill-rule="nonzero" group-id="10,32" node-id="676" stroke="none"
              target-height="42.114" target-width="33.184998" target-x="139.832" target-y="206.883" />
            <path
              d="M 141.44 216.19 C 141.44 217.57 140.32 218.69 138.94 218.69 C 137.57 218.69 136.45 217.57 136.45 216.19 C 136.45 214.82 137.57 213.70 138.94 213.70 C 140.32 213.70 141.44 214.82 141.44 216.19 Z"
              fill="#6e6e96" fill-rule="nonzero" node-id="680" stroke="none" target-height="4.9839935"
              target-width="4.9839935" target-x="136.453" target-y="213.701" />
            <path
              d="M 214.73 169.12 C 215.24 167.56 216.84 165.63 218.29 164.84 L 218.30 164.84 C 219.75 164.06 219.75 162.77 218.30 161.99 L 218.29 161.98 C 216.84 161.20 215.16 159.43 214.55 158.05 C 213.94 156.67 212.94 156.67 212.33 158.05 C 211.72 159.43 210.04 161.20 208.59 161.98 L 208.58 161.99 C 207.13 162.77 207.13 164.05 208.58 164.84 L 208.59 164.84 C 210.04 165.63 211.64 167.56 212.15 169.12 L 212.51 170.23 C 213.02 171.79 213.85 171.79 214.37 170.23 L 214.73 169.12 Z"
              fill="#ffffff" fill-rule="nonzero" group-id="11,33" node-id="685" stroke="none" target-height="15.12001"
              target-width="12.619995" target-x="207.13" target-y="156.672" />
            <path
              d="M 29.00 53.00 C 29.68 50.92 31.80 48.37 33.73 47.33 L 33.73 47.32 C 35.66 46.28 35.66 44.58 33.73 43.54 L 33.73 43.53 C 31.80 42.49 29.57 40.14 28.76 38.32 C 27.95 36.49 26.63 36.49 25.82 38.32 C 25.01 40.14 22.77 42.49 20.86 43.53 L 20.84 43.54 C 18.93 44.58 18.93 46.28 20.84 47.32 L 20.86 47.33 C 22.77 48.37 24.91 50.92 25.58 53.00 L 26.06 54.47 C 26.74 56.55 27.85 56.55 28.52 54.47 L 29.00 53.00 Z"
              fill="#ffb0b8" fill-rule="nonzero" group-id="11,34" node-id="690" stroke="none" target-height="20.058998"
              target-width="16.732002" target-x="18.925" target-y="36.49" />
            <path
              d="M 15.23 188.22 C 15.85 186.33 17.78 184.01 19.53 183.07 L 19.54 183.06 C 21.28 182.12 21.28 180.57 19.54 179.63 L 19.53 179.62 C 17.78 178.68 15.76 176.54 15.02 174.89 C 14.29 173.23 13.08 173.23 12.35 174.89 C 11.62 176.54 9.59 178.68 7.84 179.62 L 7.83 179.63 C 6.09 180.57 6.09 182.12 7.83 183.06 L 7.84 183.07 C 9.59 184.01 11.52 186.34 12.13 188.22 L 12.57 189.55 C 13.18 191.44 14.19 191.44 14.80 189.55 L 15.23 188.22 Z"
              fill="#7fdcff" fill-rule="nonzero" group-id="11,35" node-id="695" stroke="none" target-height="18.213013"
              target-width="15.192999" target-x="6.086" target-y="173.232" />
            <path
              d="M 228.62 208.89 C 229.26 206.95 231.25 204.55 233.05 203.58 L 233.06 203.57 C 234.86 202.60 234.86 201.00 233.06 200.03 L 233.05 200.02 C 231.25 199.04 229.16 196.85 228.40 195.13 C 227.64 193.43 226.40 193.43 225.64 195.13 C 224.89 196.85 222.79 199.04 221.00 200.02 L 220.98 200.03 C 219.18 201.00 219.18 202.60 220.98 203.57 L 221.00 203.58 C 222.80 204.56 224.79 206.95 225.42 208.89 L 225.88 210.27 C 226.51 212.22 227.55 212.22 228.18 210.27 L 228.62 208.89 Z"
              fill="#dec2ff" fill-rule="nonzero" group-id="11,36" node-id="699" stroke="none" target-height="18.791"
              target-width="15.681" target-x="219.181" target-y="193.425" />
            <path
              d="M 201.97 22.50 C 202.43 21.07 203.89 19.32 205.22 18.60 L 205.22 18.60 C 206.54 17.88 206.54 16.71 205.22 16.00 L 205.22 15.99 C 203.90 15.28 202.36 13.67 201.80 12.41 C 201.25 11.15 200.34 11.15 199.78 12.41 C 199.22 13.67 197.69 15.28 196.37 15.99 L 196.37 16.00 C 195.05 16.71 195.05 17.88 196.37 18.60 L 196.37 18.60 C 197.69 19.32 199.15 21.07 199.62 22.50 L 199.95 23.51 C 200.42 24.94 201.18 24.94 201.64 23.51 L 201.97 22.50 Z"
              fill="#ffb0b8" fill-rule="nonzero" group-id="11,37" node-id="704" stroke="none" target-height="13.788001"
              target-width="11.494003" target-x="195.047" target-y="11.155" />
            <path
              d="M 95.28 214.53 C 95.75 213.10 97.21 211.35 98.53 210.63 L 98.54 210.63 C 99.86 209.91 99.86 208.74 98.54 208.03 L 98.53 208.02 C 97.21 207.31 95.68 205.70 95.12 204.44 C 94.56 203.19 93.65 203.19 93.10 204.44 C 92.54 205.70 91.01 207.31 89.69 208.02 L 89.68 208.03 C 88.36 208.74 88.36 209.91 89.68 210.63 L 89.69 210.63 C 91.01 211.35 92.47 213.11 92.94 214.53 L 93.27 215.54 C 93.73 216.97 94.49 216.97 94.95 215.54 L 95.28 214.53 Z"
              fill="#ffb0b8" fill-rule="nonzero" group-id="11,38" node-id="709" stroke="none" target-height="13.789001"
              target-width="11.491005" target-x="88.365" target-y="203.185" />
            <path
              d="M 67.09 112.97 C 67.55 111.54 69.01 109.79 70.34 109.08 L 70.34 109.07 C 71.66 108.36 71.66 107.19 70.34 106.47 L 70.34 106.47 C 69.02 105.75 67.48 104.14 66.92 102.88 C 66.37 101.63 65.46 101.63 64.90 102.88 C 64.35 104.14 62.81 105.75 61.49 106.47 L 61.48 106.47 C 60.17 107.19 60.17 108.36 61.48 109.07 L 61.49 109.08 C 62.81 109.79 64.27 111.55 64.74 112.97 L 65.07 113.98 C 65.54 115.41 66.30 115.41 66.76 113.98 L 67.09 112.97 Z"
              fill="#ffffff" fill-rule="nonzero" group-id="11,39" node-id="714" stroke="none" target-height="13.787003"
              target-width="11.494003" target-x="60.168" target-y="101.626" />
          </svg>
        </div>
        <p style="font-size: 14px;">新增成单数{{ turnover }}</p>
      </div>
      <div style="width: 30%;margin-left: 100px;">
        <Income5copy2 :list5="list555" :times="times"></Income5copy2>
      </div>
      <div style="width: 30%;margin-left: 100px;">
        <Income6copy2 :list6="list333" :times="times"></Income6copy2>
      </div>
    </div>


    <div class="title">进出款分析 {{ handleGetTimeString(createTime && createTime.length > 0 ? createTime[0] : '') }} - {{ handleGetTimeString(createTime && createTime.length > 0 ? createTime[1] : '' ) }}</div>
    <div class="textbox">
      <div style="display: flex; width: 70%;">
        <div style="border: 1px solid #9a9191;padding: 20px;margin-left: 50px; height: 20px; width: 150px;">
          <div style="margin-top: -11px;">总体总金额</div>
          <div style="font-size: 20px; margin-top: 2px;font-weight: 700;">{{ allSumMoney }}</div>
        </div>
        <div style="border: 1px solid #9a9191;padding: 20px;margin-left: 10px; height: 20px; width: 150px;">
          <div style="margin-top: -11px;">定金总金额</div>
          <div style="font-size: 20px; margin-top: 2px;font-weight: 700;">{{ depositSumMoney }}</div>
        </div>
        <div style="border: 1px solid #9a9191;padding: 20px;margin-left: 10px; height: 20px; width: 150px;">
          <div style="margin-top: -11px;">成单总金额</div>
          <div style="font-size: 20px; margin-top: 2px;font-weight: 700;">{{ orderSumMoney }}</div>
        </div>
        <div style="border: 1px solid #9a9191;padding: 20px;margin-left: 10px; height: 20px; width: 150px;">
          <div style="margin-top: -11px;">续费总金额</div>
          <div style="font-size: 20px; margin-top: 2px;font-weight: 700;">{{ renewalSumMoney }}</div>
        </div>
        <div style="border: 1px solid #9a9191;padding: 20px;margin-left: 10px; height: 20px; width: 150px;">
          <div style="margin-top: -11px;">退费总金额</div>
          <div style="font-size: 20px; margin-top: 2px;font-weight: 700;">{{ refundSumMoney }}</div>
        </div>
      </div>
      <div class="chart" style=" height: 150px;margin-left: 100px;width: 30%;">
         <Income4copy2  :list4="list4" :times="times"></Income4copy2>
      </div>
    </div>

  

  </div>
</template>

<script>
import axios from 'axios'
import apiBaseUrl from '../../config/api'
import Income from './components/income.vue'
import Income1 from './components/income1.vue'
import Income3 from './components/income3.vue'
import Income4 from './components/income4.vue'
import Income5 from './components/income5.vue'
import Income6 from './components/income6.vue'
import Income7 from './components/income7.vue'
import Income8 from './components/income8.vue'
import linechart from './components/linechart.vue'
import itemchart from './components/itemchart.vue'
import itemschart from './components/itemschart.vue'


import Income4copy2 from './components/income4copy2.vue'
import Income5copy from './components/income5copy.vue'
import Income5copy2 from './components/income5copy2.vue'
import Income6copy from './components/Income6copy.vue'
import Income6copy2 from './components/Income6copy2.vue'



import tongji from './tongji.vue'

import loadingUtils from "../utils/loading";


// import * as echarts from 'echarts';
export default {
  name: "",
  components: {
    Income,
    Income1,
    Income3,
    Income4,
    Income5,
    Income6,
    Income7,
    Income8,
    linechart,
    itemchart,
    itemschart,
    tongji,

    Income4copy2,
    Income5copy,
    Income5copy2,
    Income6copy,
    Income6copy2,
  },
  data () {
    return {


      colorList:['#c23531','#2f4554','#61a0a8','#d48265','#91c7ae','#749f83','#ca8622','#bda29a','#6e7074','#546570','#c4ccd3','#81e32a',],

      showCustomerFunding: false,

      showTongji: false,
      tongjiBoj:{
        eventObj: null,
        createTime: [],
      },

      value1: "",
      value2: "",
      selectValue: "3",
      selectValueType: "1",
      options: [{
        value: '1',
        label: '按年'
      }, {
        value: '2',
        label: '按月'
      }, {
        value: '3',
        label: '按日'
      },],
      optionsType: [{
        value: '1',
        label: '按客资来源'
      }, {
        value: '2',
        label: '按成交金额'
      }],
      times: "",//年月日
      createTime: [],//时间
      addCustomerNum: "",//添加客资数
      orderCustomerNum: "",//成交客资数
      turnover: "",//成交额
      list1: [],//添加类型
      list2: [],//成单状态

      list3: [],//微信状态
      list33: [],//微信状态
      list333: [],//微信状态

      list4: [],//教师占比

      list5: [],//客资来源
      list55: [],
      list555: [],

      list6: [],//客资来源负责人
      list8: [],//客资来源金额
      list9: [],//客资来源负责人钱数
      list10: [],//柱状图数据
      list11: [],//柱状图数据
      list7: {},//添加客资数与成单客资数


      sources : [],
      sourcesPeople : [],
      optionsList : [],

      searchSource: "",  
      searchSourcesPeople : "",  
      inputAcount : "",   



      orderSumMoney:0,
      refundSumMoney:0,
      allSumMoney:0,
      depositSumMoney:0,
      renewalSumMoney:0,



    }
  },
  created () {
    loadingUtils.startLoading()
    this.getTime()
    
    // this.getAddType()
    this.getPayType()
    this.getOrderstatus()
    // this.getWxStatus()
    this.getTeacherType()
    // this.getSource()
    this.getSsourcePeople()
    // this.getTurnover()
    this.getLineByDay()
    // this.getSourcePay()
    // this.getSourcePeoplePay()
    this.getBarPeople()
    // this.getbarPay()
  },
  mounted () {
    this.$nextTick(() => {
      this.getSource()
      this.getTeacherType()
      this.handleinAndOutPay()
      this.getOrderCustomerNum()
      this.getAddCustomerNum()
    })


    this.getStartAndEndDates();  
    this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj'))

    axios .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo')  }  }) .then(response => {
      this.sourcesPeople = response.data.data.list;
    }) .catch(error => {
      console.error(error);
    })

    axios.get(`${apiBaseUrl}/customerinformation/sourcelist`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')  }  }) .then(response => {
      this.sources = response.data.data.list;
    }).catch(error => {
      console.error(error);
    })


    setTimeout(() => {
      loadingUtils.endLoading()
    }, 1000)
  },
  methods: {


    handleinAndOutPay(){
        axios.post(`${apiBaseUrl}/stat/inAndOutPay`, { time: this.times },{headers:{'authorization': sessionStorage.getItem('tokenInfo')}, }).then(res => {
          if (res.data.code == 200) {
            let datas = res.data.data
            this.orderSumMoney = datas.orderSumMoney
            this.refundSumMoney = datas.refundSumMoney
            this.allSumMoney = datas.allSumMoney
            this.depositSumMoney = datas.depositSumMoney
            this.renewalSumMoney = datas.renewalSumMoney
          } else {
            this.orderSumMoney = 0
            this.refundSumMoney = 0
            this.allSumMoney = 0
            this.depositSumMoney = 0
            this.renewalSumMoney = 0
            this.$message({ message: res.data.message || res.data.msg ,type: "error"  });
          }
        }).catch(error => {
          this.orderSumMoney = 0
          this.refundSumMoney = 0
          this.allSumMoney = 0
          this.depositSumMoney = 0
          this.renewalSumMoney = 0
          this.$message({ message: error,  type: "error"  });
        });

        axios.post(`${apiBaseUrl}/stat/paymentChannels`, { time: this.times },{headers:{'authorization': sessionStorage.getItem('tokenInfo')}, }).then(res => {
          if (res.data.code == 200) {
            this.list4 = res.data.data
          } else {
            this.list4 = []
            this.$message({ message: res.data.message || res.data.msg , type: "error"  });
          }
        }).catch(error => {
          this.list4 = []
          this.$message({ message: error,  type: "error"  });
        });
    },

    handleGetTimeString(time){
      const dayString = time.slice(5, 10);
      const newString = dayString.replace(/-/g, '/');
      return newString
    },

    handleClickClre(){
      this.getStartAndEndDates();
      this.searchSource = "";
      this.searchSourcesPeople = "";
      this.inputAcount = "";
    },

    handleClear1(){

    },

    handleClear2(){

    },

    handleClear3(){

    },


    handleToToday(){
      loadingUtils.startLoading()


      this.getStartAndEndDayS()
      this.getAddCustomerNum()
      this.getOrderCustomerNum()
      this.getPayType()
      this.getOrderstatus()
      // this.getSourcePay()
      // this.getSourcePeoplePay()
      // this.getWxStatus()
      this.getTeacherType()
      this.getSource()
      this.getSsourcePeople()
      // this.getTurnover()
      this.handleinAndOutPay()


      setTimeout(() => {
          loadingUtils.endLoading()
      }, 1000)
    },
    handleToYesterday(){
      loadingUtils.startLoading()

      this.getStartAndEndDay()
      this.getAddCustomerNum()
      this.getOrderCustomerNum()
      this.getPayType()
      this.getOrderstatus()
      // this.getSourcePay()
      // this.getSourcePeoplePay()
      // this.getWxStatus()
      this.getTeacherType()
      this.getSource()
      this.getSsourcePeople()
      // this.getTurnover()
      this.handleinAndOutPay()


      setTimeout(() => {
          loadingUtils.endLoading()
      }, 1000)
        
    },
    handleToLastSevenDays(){
      loadingUtils.startLoading()

      this.getStartAndEndDates();
      this.getAddCustomerNum()
      this.getOrderCustomerNum()
      this.getPayType()
      this.getOrderstatus()
      // this.getSourcePay()
      // this.getSourcePeoplePay()
      // this.getWxStatus()
      this.getTeacherType()
      this.getSource()
      this.getSsourcePeople()
      // this.getTurnover()
      this.handleinAndOutPay()


      setTimeout(() => {
          loadingUtils.endLoading()
      }, 1000)
    },


   getStartAndEndDayS(){
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份从0开始
      const day = String(today.getDate()).padStart(2, '0');
      this.createTime = [ `${year}-${month}-${day}`,  `${year}-${month}-${day}`];
      this.times = this.createTime
   },   


    getStartAndEndDay(){
      const endDate = new Date();
      endDate.setHours(0, 0, 0, 0);

      const startDate = new Date(endDate);
      startDate.setDate(endDate.getDate() - 1);

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      this.createTime = [formatDate(startDate), formatDate(startDate)];
      this.times = this.createTime
    },


    // 获取当前开始时间是前6天 结束为当天
    getStartAndEndDates() {
      const endDate = new Date();
      endDate.setHours(0, 0, 0, 0);

      const startDate = new Date(endDate);
      startDate.setDate(endDate.getDate() - 6);

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      this.createTime = [formatDate(startDate), formatDate(endDate)];
      this.times = this.createTime
    },

    handleCustomerFunding(){
      this.showCustomerFunding = false
    },

   

    handleClick(){
      // this.showCustomerFunding = true
      this.tongjiBoj = {  createTime: (this.createTime && this.createTime.length > 0) ? this.createTime[0].substring(0,7) : (this.times && this.times.length > 0) ? this.times[0].substring(0,7) : '' ,  eventObj: event, }
      this.showTongji = true
    },


    handleeventObj(event){
      this.tongjiBoj = {  createTime: this.createTime ? this.createTime : this.times ,  eventObj: event, }
      this.showTongji = true
    },

    handlescreenshotCler(){
      this.showTongji = false
    },

    qingchu () {
      this.value1 = ''
    },
    selectQc () {
      // this.value2=''
      if (this.selectValueType == 1) {
        this.getBarPeople()
      } else {
        this.getbarPay()
      }
    },
    handleClear () {
      loadingUtils.startLoading()
      if (this.createTime == null) {
        // 获取当前时间
        const today = new Date();
        // 获取当前时间(today)的年份
        const year = today.getFullYear();
        // 获取月份
        const month = String(today.getMonth() + 1).padStart(2, '0');
        // 获取当前日
        const day = String(today.getDate()).padStart(2, '0');
        // 得到年月日
        const thisDayDate = `${year}-${month}-${day}`; //打印当前日期
        this.times = [thisDayDate, thisDayDate]

        this.getAddCustomerNum()
        this.getOrderCustomerNum()
        // this.getAddType()
        this.getPayType()
        this.getOrderstatus()
        // this.getSourcePay()
        // this.getWxStatus()
        // this.getSourcePeoplePay()
        this.getTeacherType()
        this.getSource()
        this.getSsourcePeople()
        // this.getTurnover()
        this.handleinAndOutPay()
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 1000)
      } else {
        this.times = this.createTime
        this.getAddCustomerNum()
        this.getOrderCustomerNum()
        // this.getAddType()
        this.getPayType()
        this.getOrderstatus()
        // this.getSourcePay()
        // this.getSourcePeoplePay()
        // this.getWxStatus()
        this.getTeacherType()
        this.getSource()
        this.getSsourcePeople()
        // this.getTurnover()
        this.handleinAndOutPay()
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 1000)
      }
    },
    goTo () {
      // this.$router.push("/classtasklist")

    },
    //柱状图搜索
    barPeople () {
      if (this.selectValueType == "1") {
        axios
          .post(`${apiBaseUrl}/stat/barPeople`, { date: this.value2 },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
          .then(res => {
            if (res.data.code == 200) {
              this.list10 = res.data.data
              this.list10.unshift(['', '小红书', '视频号', '抖音'])
            } else {
              this.$message({
                message: "获取柱状图数据失败",
                type: "error"
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.list11 = []
        axios
          .post(`${apiBaseUrl}/stat/barPay`, { date: this.value2 },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
          .then(res => {
            if (res.data.code == 200) {
              var dataList = res.data.data
              this.list11.push(['', '定金', '全额', '分期', '续费'],)
              for (var i = 0; i < dataList.length; i++) {
                dataList[i].value.unshift(dataList[i].name)
                this.list11.push(dataList[i].value)
              }
            } else {
              this.$message({
                message: "获取柱状图数据失败",
                type: "error"
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    //获取当前时间
    getTime () {
      // 获取当前时间
      const today = new Date();
      // 获取当前时间(today)的年份
      const year = today.getFullYear();
      // 获取月份
      const month = String(today.getMonth() + 1).padStart(2, '0');
      // 获取当前日
      const day = String(today.getDate()).padStart(2, '0');
      // 得到年月日
      const thisDayDate = `${year}-${month}-${day}`; //打印当前日期
      this.times = [thisDayDate, thisDayDate]
      this.value1 = thisDayDate
      this.value2 = thisDayDate
    },

    getAddCustomerNum () {
        axios.post(`${apiBaseUrl}/stat/addCustomerNum`, { time: this.createTime, type: 1 },{headers:{'authorization': sessionStorage.getItem('tokenInfo')}, }).then(res => {
          if (res.data.code == 200) {
            this.addCustomerNum = res.data.data
          } else {
            this.addCustomerNum = 0
            this.$message({ message: "获取添加客资数失败",  type: "error"  });
          }
        }).catch(error => {
          this.addCustomerNum = 0
          this.$message({ message: error,  type: "error"  });
        });
        axios.post(`${apiBaseUrl}/stat/addCustomerNum`, { time: this.createTime, type: 2 },{headers:{'authorization': sessionStorage.getItem('tokenInfo')}, }).then(res => {
          if (res.data.code == 200) {
            this.orderCustomerNum = res.data.data
          } else {
            this.orderCustomerNum = 0
            this.$message({ message: "获取添加客资数失败",  type: "error"  });
          }
        }).catch(error => {
          this.orderCustomerNum = 0
          this.$message({ message: error,  type: "error"  });
        });
        axios.post(`${apiBaseUrl}/stat/addCustomerNum`, { time: this.createTime, type: 3 },{headers:{'authorization': sessionStorage.getItem('tokenInfo')}, }).then(res => {
          if (res.data.code == 200) {
            this.turnover = res.data.data
          } else {
            this.turnover = 0
            this.$message({ message: "获取添加客资数失败",  type: "error"  });
          }
        }).catch(error => {
          this.turnover = 0
          this.$message({ message: error,  type: "error"  });
        });
    },
   
    getOrderCustomerNum () {
      axios
        .post(`${apiBaseUrl}/stat/orderCustomerNum`, { time: this.times },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
            this.orderCustomerNum = res.data.data
          } else {
            this.$message({
              message: "获取成单额失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //成交额
    getTurnover () {
      axios
        .post(`${apiBaseUrl}/stat/turnover`, { time: this.times },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
            this.turnover = res.data.data
          } else {
            this.$message({
              message: "获取成交额失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    //获取客资来源负责人钱数
    getSourcePeoplePay () {
      axios
        .post(`${apiBaseUrl}/stat/sourcePeoplePay`, { time: this.times },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
            this.list9 = res.data.data
          } else {
            this.$message({
              message: "客资来源负责人钱数",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取客资来源负责人
    getSsourcePeople () {
      axios
        .post(`${apiBaseUrl}/stat/sourcePeople`, { time: this.times },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
            this.list6 = res.data.data.map((item)=>{
              if(item.name === '思琪'){
                  item.itemStyle = { color: '#81e32a' }
              }
              return item
            })
          } else {
            this.$message({
              message: "获取客资来源失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //客资来源金额
    getSourcePay () {
      axios
        .post(`${apiBaseUrl}/stat/sourcePay`, { time: this.times },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
            this.list8 = res.data.data
          } else {
            this.$message({
              message: "获取客资来源金额",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // //获取添加类型
    // getAddType () {
    //   axios
    //     .post(`${apiBaseUrl}/stat/addType`, { time: this.times })
    //     .then(res => {
    //       if (res.data.code == 200) {
    //         this.list1 = res.data.data
    //       } else {
    //         this.$message({
    //           message: "获取添加类型失败",
    //           type: "error"
    //         });
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    //付款分类
    getPayType () {
      axios
        .post(`${apiBaseUrl}/stat/payType`, { time: this.times },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
            this.list1 = res.data.data
          } else {
            this.$message({
              message: "获取添加类型失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取成单状态
    getOrderstatus () {
      axios
        .post(`${apiBaseUrl}/stat/orderStatus`, { time: this.times },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
            this.list2 = res.data.data
          } else {
            this.$message({
              message: "获取成单状态失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取微信状态
    getWxStatus () {
      axios
        .post(`${apiBaseUrl}/stat/wxStatus`, { time: this.times },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
            this.list4 = res.data.data
          } else {
            this.$message({
              message: "获取教师占比失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
   
    getTeacherType () {
        axios.post(`${apiBaseUrl}/stat/teacherType`, { time: this.times, type: 1 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
          if (res.data.code == 200) {
            this.list3 = res.data.data
          } else {
            this.list3 = []
            this.$message({  message: res.data.message || "获取教师占比失败",  type: "error" });
          }
        }) .catch(error => {
          this.list3 = []
          this.$message({  message: error || "获取教师占比失败",  type: "error" });
        });


        axios.post(`${apiBaseUrl}/stat/teacherType`, { time: this.times, type: 2 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
          if (res.data.code == 200) {
            this.list33 = res.data.data
          } else {
            this.list33 = []
            this.$message({  message: res.data.message || "获取教师占比失败",  type: "error" });
          }
        }) .catch(error => {
          this.list33 = []
          this.$message({  message: error || "获取教师占比失败",  type: "error" });
        });


        axios.post(`${apiBaseUrl}/stat/teacherType`, { time: this.times, type: 3 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
          if (res.data.code == 200) {
            this.list333 = res.data.data
          } else {
            this.list333 = []
            this.$message({  message: res.data.message || "获取教师占比失败",  type: "error" });
          }
        }) .catch(error => {
          this.list333 = []
          this.$message({  message: error || "获取教师占比失败",  type: "error" });
        });
    },
   
    getSource () {
        axios.post(`${apiBaseUrl}/stat/source`, { time: this.times, type: 1 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
          if (res.data.code == 200) {
            this.list5 = res.data.data
          } else {
            this.list5 = []
            this.$message({ message: "获取客资来源失败", type: "error" });
          }
        }).catch(error => {
          this.list5 = []
          this.$message({ message: error, type: "error" });
        });

         axios.post(`${apiBaseUrl}/stat/source`, { time: this.times, type: 2 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
          if (res.data.code == 200) {
            this.list55 = res.data.data
          } else {
            this.list55 = []
            this.$message({ message: "获取客资来源失败", type: "error" });
          }
        }).catch(error => {
          this.list55 = []
          this.$message({ message: error, type: "error" });
        });

         axios.post(`${apiBaseUrl}/stat/source`, { time: this.times, type: 3 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
          if (res.data.code == 200) {
            this.list555 = res.data.data
          } else {
            this.list555 = []
            this.$message({ message: "获取客资来源失败", type: "error" });
          }
        }).catch(error => {
          this.list555 = []
          this.$message({ message: error, type: "error" });
        });
    },
    //获取客资来源负责人
    getSsourcePeople () {
      axios
        .post(`${apiBaseUrl}/stat/sourcePeople`, { time: this.times },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
              this.list6 = res.data.data.map((item)=>{
                if(item.name === '思琪'){
                    item.itemStyle = { color: '#81e32a' }
                }
                 return item
              })
          } else {
            this.$message({
              message: "获取客资来源失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
   
    getbarPay () {
      axios
        .post(`${apiBaseUrl}/stat/barPay`, { date: this.value2 },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
            var dataList = res.data.data
            this.list11.push(['', '定金', '全额', '分期', '续费'],)
            for (var i = 0; i < dataList.length; i++) {
              dataList[i].value.unshift(dataList[i].name)
              this.list11.push(dataList[i].value)
            }
          } else {
            this.$message({
              message: "获取柱状图数据失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //柱状图数据
    getBarPeople () {
      axios
        .post(`${apiBaseUrl}/stat/barPeople`, { date: this.value2 },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
            this.list10 = res.data.data
            this.list10.unshift(['', '小红书', '视频号', '抖音'])
          } else {
            this.$message({
              message: "获取柱状图数据失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //第一次进入获取折线图数据
    getLineByDay () {
      // 获取当前时间
      const today = new Date();
      // 获取当前时间(today)的年份
      const year = today.getFullYear();
      // 获取月份
      const month = String(today.getMonth() + 1).padStart(2, '0');
      // 获取当前日
      const day = String(today.getDate()).padStart(2, '0');
      // 得到年月日
      const thisDayDate = `${year}-${month}-${day}`; //打印当前日期

      axios
        .post(`${apiBaseUrl}/stat/getLineByDay`, { date: thisDayDate },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
        .then(res => {
          if (res.data.code == 200) {
            this.list7 = res.data.data
          } else {
            this.$message({
              message: "获取添加客资数与成单客资数失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //折线图日搜索
    selectDay () {
      if (this.value1 == null) {
        this.getLineByDay()
      } else {
        axios
          .post(`${apiBaseUrl}/stat/getLineByDay`, { date: this.value1 },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
          .then(res => {
            if (res.data.code == 200) {
              this.list7 = res.data.data
            } else {
              this.$message({
                message: "获取添加客资数与成单客资数失败",
                type: "error"
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    //折线图月搜索
    selectMonth () {
      if (this.value1 == null) {
        this.getLineByDay()
      } else {
        axios
          .post(`${apiBaseUrl}/stat/getLineByMonth`, { date: this.value1 },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
          .then(res => {
            if (res.data.code == 200) {
              this.list7 = res.data.data
            } else {
              this.$message({
                message: "获取添加客资数与成单客资数失败",
                type: "error"
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    //折线图年搜索
    selectYear () {
      if (this.value1 == null) {
        // this.getLineByDay()
      } else {
        axios
          .post(`${apiBaseUrl}/stat/getLineByYear`, { date: this.value1 },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            })
          .then(res => {
            if (res.data.code == 200) {
              this.list7 = res.data.data
            } else {
              this.$message({
                message: "获取添加客资数与成单客资数失败",
                type: "error"
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
  },

}
</script>

<style scoped>
/* @import './components/index.css'; */

.linechart {
  width: 100%;
  /* display: flex;
  justify-content: flex-start;
justify-content: stretch;
  align-items: center; */
}

.chart1-row {
  height: 380px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.textbox {
  margin-top: 20px;
  display: flex;
  width: 100%;
  /* box-sizing: border-box; */
  /* justify-content: space-around; */
  margin-bottom: 90px;
}

.chart {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item {
  display: flex;
  justify-content: space-around;
  align-items: center;
}


.query {
  font-size: 14px;

}

.block {
  display: flex;
  height: 70px;
}

.proportion {
  display: flex;
  margin-left: 20px;
  margin: 13px;
  font-size: 22px;
  font-weight: bold;
}



.all {
  border: 1px solid #f0f0f0;
  background-color: #FFFFFF;
  border-radius: 8px;
  width: 33%;
  height: 171px;
  position: relative;
  margin-left: 20px;
  /* flex: auto; */
}

.title {
  font-size: 17px;
  font-weight: bold;
  display: flex;
  justify-self: start;
  padding: 0px 12px;
  line-height: 38px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.block {
    width: 70% !important;
  }
}
</style>






// WEBPACK FOOTER //
// src/statistics/Datatable.vue